webpackJsonp(["main"],{

/***/ "./mysite/resources/images/bg-8.jpg":
/*!******************************************!*\
  !*** ./mysite/resources/images/bg-8.jpg ***!
  \******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bg-8.85f039d2.jpg";

/***/ }),

/***/ "./mysite/resources/js/components/gallery-modal.js":
/*!*********************************************************!*\
  !*** ./mysite/resources/js/components/gallery-modal.js ***!
  \*********************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

__webpack_require__(/*! core-js/modules/es6.object.define-property */ "./node_modules/core-js/modules/es6.object.define-property.js");

__webpack_require__(/*! core-js/modules/es6.function.bind */ "./node_modules/core-js/modules/es6.function.bind.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CLASS_ACTIVE = 'is-active';

var GalleryModal =
/*#__PURE__*/
function () {
  _createClass(GalleryModal, null, [{
    key: "instance",
    value: function instance() {
      if (this._instance) return this._instance;
      return this._instance = new this();
    }
  }]);

  function GalleryModal() {
    _classCallCheck(this, GalleryModal);

    _defineProperty(this, "current", 0);

    this.el = document.createElement('div');
    this.content = document.createElement('div');
    this.cross = document.createElement('div');
    this.left = document.createElement('div');
    this.right = document.createElement('div');
    this.el.className = 'gallery-modal';
    this.content.className = 'gallery-modal__content';
    this.cross.className = 'gallery-modal__cross';
    this.left.className = 'gallery-modal__left';
    this.right.className = 'gallery-modal__right';
    this.items = [];
    this.el.appendChild(this.content);
    this.el.appendChild(this.cross);
    this.el.appendChild(this.left);
    this.el.appendChild(this.right);
    document.body.appendChild(this.el);
    this.close = this.close.bind(this);
    this.goLeft = this.goLeft.bind(this);
    this.goRight = this.goRight.bind(this);
    this.keyDown = this.keyDown.bind(this);
    this.init();
  }

  _createClass(GalleryModal, [{
    key: "init",
    value: function init() {
      this.cross.addEventListener('click', this.close);
      this.left.addEventListener('click', this.goLeft);
      this.right.addEventListener('click', this.goRight);
      document.addEventListener("keydown", this.keyDown);
    }
  }, {
    key: "createItem",
    value: function createItem(index, imgSrc, caption) {
      var node = document.createElement('div');
      var imageNode = document.createElement('div');
      var img = document.createElement('img');
      node.className = 'gallery-modal__item';
      imageNode.className = 'gallery-modal__image';
      img.src = imgSrc, caption;

      if (caption !== null) {
        var captionNode = document.createElement('div');
        captionNode.className = 'gallery-modal__caption'; // console.log(captionNode);

        captionNode.innerHTML = caption;
        imageNode.appendChild(captionNode);
      }

      imageNode.appendChild(img);
      node.appendChild(imageNode);
      this.content.appendChild(node);
      this.items[index] = node;
    }
  }, {
    key: "clean",
    value: function clean() {
      this.content.innerHTML = '';
      this.items = [];
    }
  }, {
    key: "open",
    value: function open(index) {
      this.current = index;
      this.el.classList.add(CLASS_ACTIVE);
      this.items[this.current].classList.add(CLASS_ACTIVE);
    }
  }, {
    key: "close",
    value: function close() {
      this.el.classList.remove(CLASS_ACTIVE);
      this.items[this.current].classList.remove(CLASS_ACTIVE);
    }
  }, {
    key: "goLeft",
    value: function goLeft() {
      var newIndex = this.current - 1;
      newIndex = newIndex < 0 ? this.items.length - 1 : newIndex;
      this.items[this.current].classList.remove(CLASS_ACTIVE);
      this.current = newIndex;
      this.items[this.current].classList.add(CLASS_ACTIVE);
    }
  }, {
    key: "goRight",
    value: function goRight() {
      var newIndex = this.current + 1;
      newIndex = newIndex > this.items.length - 1 ? 0 : newIndex;
      this.items[this.current].classList.remove(CLASS_ACTIVE);
      this.current = newIndex;
      this.items[this.current].classList.add(CLASS_ACTIVE);
    }
  }, {
    key: "keyDown",
    value: function keyDown(e) {
      // Esc
      if (e.which === 27) {
        // console.log('Gallery Modal: Esc key pressed.');
        this.close();
      } // Left arrow


      if (e.which === 37) {
        this.goLeft();
      } // Right arrow


      if (e.which === 39) {
        this.goRight();
      }
    }
  }]);

  return GalleryModal;
}();

exports.default = GalleryModal;

/***/ }),

/***/ "./mysite/resources/js/components/opInview/opInview.js":
/*!*************************************************************!*\
  !*** ./mysite/resources/js/components/opInview/opInview.js ***!
  \*************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

__webpack_require__(/*! core-js/modules/es6.object.define-property */ "./node_modules/core-js/modules/es6.object.define-property.js");

__webpack_require__(/*! core-js/modules/es6.regexp.replace */ "./node_modules/core-js/modules/es6.regexp.replace.js");

__webpack_require__(/*! core-js/modules/es6.function.bind */ "./node_modules/core-js/modules/es6.function.bind.js");

var _AF = _interopRequireDefault(__webpack_require__(/*! ./../../helpers/AF */ "./mysite/resources/js/helpers/AF.js"));

var _rect = __webpack_require__(/*! ./../../helpers/rect */ "./mysite/resources/js/helpers/rect.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var OpInview =
/*#__PURE__*/
function () {
  function OpInview(el) {
    var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    _classCallCheck(this, OpInview);

    _defineProperty(this, "active", null);

    _defineProperty(this, "settings", {
      start: 0.2,
      end: 0.8,
      class: 'is-inview',
      deactivate: false,
      activateCallback: null,
      deactivateCallback: null
    });

    this.el = el;
    this.rect = new _rect.Rect({
      el: this.el
    });
    this.af = _AF.default.instance();
    this.read = this.read.bind(this);
    this.write = this.write.bind(this);
    this.activate = this.activate.bind(this);
    this.deactivate = this.deactivate.bind(this);

    if (settings === null) {
      // Grab from attribute
      var attr = JSON.parse(this.el.getAttribute('op-inview').replace(/'/g, '"'));
      if (attr.start) this.settings.start = parseFloat(attr.start);
      if (attr.end) this.settings.end = parseFloat(attr.end);
      if (attr.class) this.settings.class = attr.class;
      if (attr.deactivate) this.settings.deactivate = parseInt(attr.deactivate) !== 0;
    } else {
      // Grab from settings passed to class
      if (typeof settings.start !== 'undefined') this.settings.start = parseFloat(settings.start);
      if (typeof settings.end !== 'undefined') this.settings.end = parseFloat(settings.end);
      if (typeof settings.class !== 'undefined') this.settings.class = settings.class;
      if (typeof settings.deactivate !== 'undefined') this.settings.deactivate = parseInt(settings.deactivate) !== 0;
      if (typeof settings.activateCallback !== 'undefined') this.settings.activateCallback = settings.activateCallback;
      if (typeof settings.deactivateCallback !== 'undefined') this.settings.deactivateCallback = settings.deactivateCallback;
    }

    this.af.addRead(this.read);
    this.af.addWrite(this.write);
  }

  _createClass(OpInview, [{
    key: "disconnect",
    value: function disconnect() {
      this.af.removeRead(this.read);
      this.af.removeWrite(this.write);
    }
  }, {
    key: "read",
    value: function read() {
      this.rect.tick();
    }
  }, {
    key: "write",
    value: function write() {
      if (this.rect.progress >= this.settings.start && this.rect.progress <= this.settings.end) {
        this.activate();
      } else {
        if (this.settings.deactivate) {
          this.deactivate();
        }
      }
    }
  }, {
    key: "activate",
    value: function activate() {
      if (this.active && this.active !== null) return; // console.log('activate');

      this.active = true;
      this.el.classList.add(this.settings.class);

      if (this.settings.activateCallback) {
        this.settings.activateCallback();
      }

      if (!this.settings.deactivate) {
        this.af.removeRead(this.read);
        this.af.removeWrite(this.write);
      }
    }
  }, {
    key: "deactivate",
    value: function deactivate() {
      if (!this.active && this.active !== null) return;
      console.log('deactivate', !this.active);
      this.active = false;
      this.el.classList.remove(this.settings.class);

      if (this.settings.deactivateCallback) {
        this.settings.deactivateCallback();
      }
    }
  }]);

  return OpInview;
}();

exports.default = OpInview;

/***/ }),

/***/ "./mysite/resources/js/components/opSlider/_animation.js":
/*!***************************************************************!*\
  !*** ./mysite/resources/js/components/opSlider/_animation.js ***!
  \***************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

__webpack_require__(/*! core-js/modules/es6.object.define-property */ "./node_modules/core-js/modules/es6.object.define-property.js");

__webpack_require__(/*! core-js/modules/es6.function.bind */ "./node_modules/core-js/modules/es6.function.bind.js");

var _AF = _interopRequireDefault(__webpack_require__(/*! ./../../helpers/AF */ "./mysite/resources/js/helpers/AF.js"));

var _bezierEasing = _interopRequireDefault(__webpack_require__(/*! ./../../helpers/bezier-easing */ "./mysite/resources/js/helpers/bezier-easing.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Animation =
/*#__PURE__*/
function () {
  function Animation(el) {
    _classCallCheck(this, Animation);

    _defineProperty(this, "type", 'drag');

    _defineProperty(this, "x", 0);

    _defineProperty(this, "xAnim", 0);

    _defineProperty(this, "stopped", true);

    _defineProperty(this, "_drag", {
      step: 0.12
    });

    _defineProperty(this, "_release", {
      progres: 0,
      duration: 1000,
      timeStart: null,
      xStart: 0,
      distance: 0,
      ease: (0, _bezierEasing.default)(0.135, 0.435, 0.12, 0.975)
    });

    this.el = el;
    this._write = this._write.bind(this);
    this._render = this._render.bind(this);
    this.af = _AF.default.instance();
  }

  _createClass(Animation, [{
    key: "drag",
    value: function drag(x) {
      this.type = 'drag';
      this.x = x;

      this._start();
    }
  }, {
    key: "release",
    value: function release(x) {
      var _this = this;

      this.af.onNextWrite(function () {
        var r = _this._release;
        _this.type = 'release';
        _this.x = x;
        r.progress = 0;
        r.timeStart = window.performance.now();
        r.xStart = _this.xAnim;
        r.distance = _this.x - _this.xAnim;

        _this._start();
      });
    }
  }, {
    key: "jump",
    value: function jump(x) {
      var _this2 = this;

      this.af.onNextWrite(function () {
        _this2.x = x;
        _this2.xAnim = x;

        _this2._render();
      });
    }
  }, {
    key: "offset",
    value: function offset(x) {
      var _this3 = this;

      this.af.onNextWrite(function () {
        _this3.xAnim = _this3.xAnim - x;
      });
    }
  }, {
    key: "_write",
    value: function _write() {
      this._tick();

      this._render();
    }
  }, {
    key: "_render",
    value: function _render() {
      // console.log('_render');
      this.el.style.transform = 'translateX(' + this.xAnim + 'px)';
    }
  }, {
    key: "_tick",
    value: function _tick() {
      if (Math.abs(this.x - this.xAnim) < 1) {
        this._stop();

        return;
      }

      switch (this.type) {
        case 'drag':
          this.xAnim += (this.x - this.xAnim) * this._drag.step;
          break;

        case 'release':
          var r = this._release;

          if (r.progress < r.duration) {
            r.progress = Math.min(window.performance.now() - r.timeStart, r.duration);
            this.xAnim = r.xStart + r.distance * r.ease(r.progress / r.duration);
          } else {
            this._stop();
          }

          break;
      }
    }
  }, {
    key: "_start",
    value: function _start() {
      if (!this.stopped) return;
      this.stopped = false;
      this.af.addWrite(this._write);
    }
  }, {
    key: "_stop",
    value: function _stop() {
      if (this.stopped) return;
      this.stopped = true;
      this.af.removeWrite(this._write);
    }
  }]);

  return Animation;
}();

exports.default = Animation;

/***/ }),

/***/ "./mysite/resources/js/components/opSlider/_autoplay.js":
/*!**************************************************************!*\
  !*** ./mysite/resources/js/components/opSlider/_autoplay.js ***!
  \**************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

__webpack_require__(/*! core-js/modules/es6.object.define-property */ "./node_modules/core-js/modules/es6.object.define-property.js");

__webpack_require__(/*! core-js/modules/es6.function.bind */ "./node_modules/core-js/modules/es6.function.bind.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Autoplay =
/*#__PURE__*/
function () {
  function Autoplay(config) {
    _classCallCheck(this, Autoplay);

    _defineProperty(this, "timer", null);

    _defineProperty(this, "stopped", true);

    _defineProperty(this, "initialised", false);

    if (typeof config.el === 'undefined') return;
    this._callback = config.callback;
    this._settings = config.settings;
    this.duration = this._settings.duration || 3000;
    this.start = this.start.bind(this);
    this.stop = this.stop.bind(this);
    this.restart = this.restart.bind(this);
  }

  _createClass(Autoplay, [{
    key: "start",
    value: function start() {
      var _this = this;

      if (!this.initialised) return;
      if (!this.stopped) return; // console.log('start Autoplay');

      clearTimeout(this.timer);
      this.stopped = false;
      this.timer = setTimeout(function () {
        // console.log('callback Autoplay', this.duration);
        _this.stopped = true;

        _this._callback();

        _this.start();
      }, this.duration);
    }
  }, {
    key: "stop",
    value: function stop() {
      if (!this.initialised) return;
      if (this.stopped) return;
      this.stopped = true;
      clearTimeout(this.timer);
    }
  }, {
    key: "restart",
    value: function restart() {
      this.stop();
      this.start();
    }
  }]);

  return Autoplay;
}();

exports.default = Autoplay;

/***/ }),

/***/ "./mysite/resources/js/components/opSlider/_controls.js":
/*!**************************************************************!*\
  !*** ./mysite/resources/js/components/opSlider/_controls.js ***!
  \**************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

__webpack_require__(/*! core-js/modules/es6.object.define-property */ "./node_modules/core-js/modules/es6.object.define-property.js");

__webpack_require__(/*! core-js/modules/es6.function.bind */ "./node_modules/core-js/modules/es6.function.bind.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CLASS_CONTROL_DISABLED = 'is-disabled';

var Controls =
/*#__PURE__*/
function () {
  function Controls(config) {
    _classCallCheck(this, Controls);

    _defineProperty(this, "initialisedNext", false);

    _defineProperty(this, "initialisedPrev", false);

    this._slider = config.slider;
    this.nextItems = config.nextItems;
    this.prevItems = config.prevItems;
    this._next = config.next;
    this._prev = config.prev;
    this.update = this.update.bind(this);
    this._handleKeydown = this._handleKeydown.bind(this);
    if (typeof this.nextItems !== 'undefined') this.initialisedNext = true;
    if (typeof this.prevItems !== 'undefined') this.initialisedPrev = true;

    if (this.initialisedNext) {
      for (var i = 0; i < this.nextItems.length; i++) {
        this.nextItems[i].addEventListener('click', this._next);
      }
    }

    if (this.initialisedPrev) {
      for (var _i = 0; _i < this.prevItems.length; _i++) {
        this.prevItems[_i].addEventListener('click', this._prev);
      }
    }

    this._slider.addEventListener('keydown', this._handleKeydown);
  }

  _createClass(Controls, [{
    key: "_handleKeydown",
    value: function _handleKeydown(e) {
      // console.log('keydown');
      if (e.keyCode === 37) {
        // console.log('left');
        this._prev();
      }

      if (e.keyCode === 39) {
        // console.log('right');
        this._next();
      }
    }
  }, {
    key: "update",
    value: function update(showNext, showPrev) {
      if (this.initialisedNext) {
        if (showNext) this._enable(this.nextItems);else this._disable(this.nextItems);
      }

      if (this.initialisedPrev) {
        if (showPrev) this._enable(this.prevItems);else this._disable(this.prevItems);
      }
    }
  }, {
    key: "_disable",
    value: function _disable(els) {
      for (var i = 0; i < els.length; i++) {
        els[i].classList.add(CLASS_CONTROL_DISABLED);
      }
    }
  }, {
    key: "_enable",
    value: function _enable(els) {
      for (var i = 0; i < els.length; i++) {
        els[i].classList.remove(CLASS_CONTROL_DISABLED);
      }
    }
  }]);

  return Controls;
}();

exports.default = Controls;

/***/ }),

/***/ "./mysite/resources/js/components/opSlider/_dots.js":
/*!**********************************************************!*\
  !*** ./mysite/resources/js/components/opSlider/_dots.js ***!
  \**********************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

__webpack_require__(/*! core-js/modules/es6.object.define-property */ "./node_modules/core-js/modules/es6.object.define-property.js");

__webpack_require__(/*! core-js/modules/es6.function.bind */ "./node_modules/core-js/modules/es6.function.bind.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CLASS_DOT_ACTIVE = 'is-active';

var Dots =
/*#__PURE__*/
function () {
  function Dots(config) {
    var _this = this;

    _classCallCheck(this, Dots);

    _defineProperty(this, "initialised", false);

    if (typeof config.el === 'undefined') return;
    this.initialised = true;
    this.el = config.el;
    this.length = config.length;
    this.select = this.select.bind(this);
    this.items = [];

    var _loop = function _loop(i) {
      _this.items[i] = document.createElement('li');

      _this.items[i].addEventListener('click', function () {
        return config.onClick(i);
      });

      _this.el.appendChild(_this.items[i]);
    };

    for (var i = 0; i < this.length; i++) {
      _loop(i);
    }
  }

  _createClass(Dots, [{
    key: "select",
    value: function select(index) {
      if (!this.initialised) return;

      for (var i = 0; i < this.length; i++) {
        this.items[i].classList.remove(CLASS_DOT_ACTIVE);
      }

      this.items[index].classList.add(CLASS_DOT_ACTIVE);
    }
  }]);

  return Dots;
}();

exports.default = Dots;

/***/ }),

/***/ "./mysite/resources/js/components/opSlider/_events.js":
/*!************************************************************!*\
  !*** ./mysite/resources/js/components/opSlider/_events.js ***!
  \************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

__webpack_require__(/*! core-js/modules/es6.object.define-property */ "./node_modules/core-js/modules/es6.object.define-property.js");

__webpack_require__(/*! core-js/modules/es6.function.bind */ "./node_modules/core-js/modules/es6.function.bind.js");

var _helpers = __webpack_require__(/*! ./_helpers */ "./mysite/resources/js/components/opSlider/_helpers.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Events =
/*#__PURE__*/
function () {
  function Events(config) {
    _classCallCheck(this, Events);

    _defineProperty(this, "_onDown", function () {});

    _defineProperty(this, "_onMove", function () {});

    _defineProperty(this, "_onUp", function () {});

    _defineProperty(this, "mouse", {
      down: false,
      moved: false,
      type: '',
      xStart: 0,
      yStart: 0,
      xDist: 0,
      yDist: 0,
      tap: false
    });

    this._frame = config.frame;
    this._list = config.list;
    this._onDown = config.onDown;
    this._onMove = config.onMove;
    this._onUp = config.onUp;
    this._onResize = config.onResize;
    this._handleLinkClick = this._handleLinkClick.bind(this);
    this._handleDown = this._handleDown.bind(this);
    this._handleMove = this._handleMove.bind(this);
    this._handleUp = this._handleUp.bind(this);

    if ('ontouchstart' in document.documentElement) {
      this._frame.addEventListener('touchstart', this._handleDown);

      this._frame.addEventListener('touchmove', this._handleMove);

      window.addEventListener('touchend', this._handleUp);
    } else {
      this._frame.addEventListener('mousedown', this._handleDown);

      this._frame.addEventListener('mousemove', this._handleMove);

      window.addEventListener('mouseup', this._handleUp);
    }

    this._list.addEventListener('click', this._handleLinkClick);
  }

  _createClass(Events, [{
    key: "_handleLinkClick",
    value: function _handleLinkClick(e) {
      console.log('click');

      if (!this.mouse.tap) {
        e.preventDefault();
        e.stopPropagation();
      }
    }
  }, {
    key: "_handleDown",
    value: function _handleDown(e) {
      var m = this.mouse,
          _onD = this._onDown;
      if (m.down) return;
      m.type = (0, _helpers.getType)(e);
      m.down = true;
      m.moved = false;
      m.tap = false;
      m.xStart = (0, _helpers.getX)(e);
      m.yStart = (0, _helpers.getY)(e);

      _onD();
    }
  }, {
    key: "_handleMove",
    value: function _handleMove(e) {
      var m = this.mouse,
          _onM = this._onMove;
      if ((0, _helpers.getType)(e) !== m.type) return;
      m.xDist = (0, _helpers.getX)(e) - m.xStart; //* this.mult;

      m.yDist = (0, _helpers.getY)(e) - m.yStart;

      if (!m.moved && Math.abs(m.yDist) > Math.abs(m.xDist)) {
        // If moved Y more than X (i.e scrolling)
        m.down = false;
      }

      if (m.down) e.preventDefault();
      if (!m.down) return;
      m.moved = true;

      _onM();
    }
  }, {
    key: "_handleUp",
    value: function _handleUp(e) {
      var m = this.mouse,
          _onU = this._onUp;
      if (!m.down) return;
      if ((0, _helpers.getType)(e) !== m.type) return;
      m.down = false;
      m.xDist = (0, _helpers.getX)(e) - m.xStart;

      if (Math.abs(m.xDist) < 5) {
        // Tap
        m.tap = true;
        return;
      } else e.preventDefault();

      _onU();
    }
  }]);

  return Events;
}();

exports.default = Events;

/***/ }),

/***/ "./mysite/resources/js/components/opSlider/_helpers.js":
/*!*************************************************************!*\
  !*** ./mysite/resources/js/components/opSlider/_helpers.js ***!
  \*************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(/*! core-js/modules/es6.object.define-property */ "./node_modules/core-js/modules/es6.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getX = getX;
exports.getY = getY;
exports.getType = getType;

function getX(e) {
  if (e.changedTouches) return e.changedTouches[0].clientX;else return e.clientX;
}

function getY(e) {
  if (e.changedTouches) return e.changedTouches[0].clientY;else return e.clientY;
}

function getType(e) {
  var type;

  switch (e.type) {
    case 'mousedown':
    case 'mouseup':
    case 'mousemove':
      type = 'mouse';
      break;

    case 'touchstart':
    case 'touchend':
    case 'touchmove':
      type = 'touch';
      break;

    case 'pointerdown':
    case 'pointerup':
    case 'pointermove':
      type = 'pointer';
      break;
  }

  return type;
}

/***/ }),

/***/ "./mysite/resources/js/components/opSlider/_slides.js":
/*!************************************************************!*\
  !*** ./mysite/resources/js/components/opSlider/_slides.js ***!
  \************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

__webpack_require__(/*! core-js/modules/es6.object.define-property */ "./node_modules/core-js/modules/es6.object.define-property.js");

__webpack_require__(/*! core-js/modules/es6.function.bind */ "./node_modules/core-js/modules/es6.function.bind.js");

__webpack_require__(/*! core-js/modules/es6.array.fill */ "./node_modules/core-js/modules/es6.array.fill.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CLASS_SLIDE_ACTIVE = 'is-slide-active';
var CLASS_SLIDE_CLONE = 'is-cloned';

var Slides =
/*#__PURE__*/
function () {
  function Slides(config) {
    _classCallCheck(this, Slides);

    _defineProperty(this, "initialised", false);

    _defineProperty(this, "widthSum", 0);

    _defineProperty(this, "clones", {
      left: {
        width: 0,
        length: 0,
        lengthOld: 0,
        arr: []
      },
      right: {
        width: 0,
        length: 0,
        lengthOld: 0,
        arr: []
      }
    });

    if (typeof config.els === 'undefined') return;
    this.initialised = true;
    this.parent = config.parent;
    this.els = config.els;
    this.mode = config.mode;
    this.length = config.els.length;
    this.rects = Array(this.length).fill(null);
    this.select = this.select.bind(this);
    this.tick = this.tick.bind(this);
    this.onFocus = this.onFocus.bind(this);

    for (var i = 0; i < this.length; i++) {
      this.els[i].setAttribute('index', i);
      this.els[i].setAttribute('tabindex', '-1');
      this.els[i].addEventListener('focus', this.onFocus);
    }
  }

  _createClass(Slides, [{
    key: "onFocus",
    value: function onFocus() {// console.log('item focused');
    }
  }, {
    key: "select",
    value: function select(index) {
      if (!this.initialised) return;

      for (var i = 0; i < this.length; i++) {
        this.els[i].classList.remove(CLASS_SLIDE_ACTIVE);
      }

      this.els[index].classList.add(CLASS_SLIDE_ACTIVE);
    }
  }, {
    key: "tick",
    value: function tick(frameWidth) {
      this.widthSum = 0;

      for (var i = 0; i < this.length; i++) {
        this.rects[i] = this.els[i].getBoundingClientRect();
        this.widthSum += this.rects[i].width;
      }

      if (this.mode.infinite) {
        this._updateClones(this.clones.left, true, frameWidth);

        this._updateClones(this.clones.right, false, frameWidth);
      }
    }
  }, {
    key: "closestSlide",
    value: function closestSlide(xDist, indexFrom, reverse) {
      var widthSlides = 0,
          width = Math.abs(xDist),
          index = indexFrom,
          length = 0,
          indexNew = indexFrom;

      while (width > widthSlides) {
        var prev = this.rects[index - 1] ? this.rects[index - 1].width * 1 / 3 : 0;
        widthSlides += this.rects[index].width * 2 / 3 + prev;
        length += 1;

        if (reverse) {
          index--;
          indexNew--;
          index = index < 0 ? this.length - 1 : index;
        } else {
          index++;
          indexNew++;
          index = index > this.length - 1 ? 0 : index;
        }
      } // console.log(index, indexFrom, length, indexNew);


      return indexNew;
    }
  }, {
    key: "_updateClones",
    value: function _updateClones(side, reverse, frameWidth) {
      var index = reverse ? this.length - 1 : 0;
      var widthVisible = frameWidth;
      side.lengthOld = side.length;
      side.width = 0;
      side.length = 0;
      if (this.mode.centered) widthVisible += frameWidth / 2; // Find out how many slides needed to fill widthVisible

      while (widthVisible > side.width) {
        side.width += this.rects[index].width;

        if (typeof side.arr[side.length] === 'undefined') {
          side.arr[side.length] = this._createClone(this.els[index]);
        }

        side.length += 1;

        if (reverse) {
          index--;
          index = index < 0 ? this.length - 1 : index;
        } else {
          index++;
          index = index > this.length - 1 ? 0 : index;
        }
      }

      this._refreshClones(side, reverse);
    }
  }, {
    key: "_createClone",
    value: function _createClone(el) {
      // console.log('create clone', );
      var clone = el.cloneNode(true);
      clone.classList.add(CLASS_SLIDE_CLONE);
      return {
        node: clone,
        inTheDom: false
      };
    } // Refreshing the DOM

  }, {
    key: "_refreshClones",
    value: function _refreshClones(side, reverse) {
      for (var i = 0; i < side.arr.length; i++) {
        if (i >= side.length) {
          if (side.arr[i].inTheDom) {
            side.arr[i].inTheDom = false;
            this.parent.removeChild(side.arr[i].node);
          }
        } else {
          if (!side.arr[i].inTheDom) {
            side.arr[i].inTheDom = true;
            if (reverse) this.parent.insertBefore(side.arr[i].node, this.parent.firstChild);else this.parent.appendChild(side.arr[i].node);
          }
        }
      }
    }
  }]);

  return Slides;
}();

exports.default = Slides;

/***/ }),

/***/ "./mysite/resources/js/components/opSlider/opSlider.js":
/*!*************************************************************!*\
  !*** ./mysite/resources/js/components/opSlider/opSlider.js ***!
  \*************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

__webpack_require__(/*! core-js/modules/es6.object.define-property */ "./node_modules/core-js/modules/es6.object.define-property.js");

__webpack_require__(/*! core-js/modules/es6.function.bind */ "./node_modules/core-js/modules/es6.function.bind.js");

__webpack_require__(/*! core-js/modules/es6.array.fill */ "./node_modules/core-js/modules/es6.array.fill.js");

var _rect = __webpack_require__(/*! ./../../helpers/rect */ "./mysite/resources/js/helpers/rect.js");

var easing = _interopRequireWildcard(__webpack_require__(/*! ./../../helpers/ease-adv */ "./mysite/resources/js/helpers/ease-adv.js"));

var _bezierEasing = _interopRequireDefault(__webpack_require__(/*! ./../../helpers/bezier-easing */ "./mysite/resources/js/helpers/bezier-easing.js"));

var _AF = _interopRequireDefault(__webpack_require__(/*! ./../../helpers/AF */ "./mysite/resources/js/helpers/AF.js"));

var _events = _interopRequireDefault(__webpack_require__(/*! ./_events */ "./mysite/resources/js/components/opSlider/_events.js"));

var _dots = _interopRequireDefault(__webpack_require__(/*! ./_dots */ "./mysite/resources/js/components/opSlider/_dots.js"));

var _controls = _interopRequireDefault(__webpack_require__(/*! ./_controls */ "./mysite/resources/js/components/opSlider/_controls.js"));

var _animation = _interopRequireDefault(__webpack_require__(/*! ./_animation */ "./mysite/resources/js/components/opSlider/_animation.js"));

var _slides = _interopRequireDefault(__webpack_require__(/*! ./_slides */ "./mysite/resources/js/components/opSlider/_slides.js"));

var _autoplay = _interopRequireDefault(__webpack_require__(/*! ./_autoplay */ "./mysite/resources/js/components/opSlider/_autoplay.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var OpSlider =
/*#__PURE__*/
function () {
  function OpSlider(config) {
    _classCallCheck(this, OpSlider);

    _defineProperty(this, "index", 0);

    _defineProperty(this, "x", 0);

    _defineProperty(this, "xMin", 0);

    _defineProperty(this, "xMax", 0);

    _defineProperty(this, "indexMax", null);

    this.slider = config.slider;
    this.list = config.list;
    this.frame = config.frame;
    this.rect = this.frame.getBoundingClientRect();
    this.length = config.slides.length;
    this.indexMax = this.length - 1;
    this.mode = {
      centered: config.mode.centered || false,
      infinite: config.mode.infinite || false,
      multiple: config.mode.multiple || false,
      updateDotsOnDrag: config.mode.updateDotsOnDrag || false,
      fill: config.mode.centered || config.mode.infinite ? false : config.mode.fill || false,
      loop: config.mode.loop || false
    };
    this.af = _AF.default.instance();
    this.onResize = this.onResize.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onDown = this.onDown.bind(this);
    this.onMove = this.onMove.bind(this);
    this.onUp = this.onUp.bind(this);
    this.tick = this.tick.bind(this);
    this.prev = this.prev.bind(this);
    this.next = this.next.bind(this);
    this.select = this.select.bind(this);
    this.events = new _events.default({
      frame: this.frame,
      list: this.list,
      onDown: this.onDown,
      onMove: this.onMove,
      onUp: this.onUp
    });
    this.dots = new _dots.default({
      el: config.dots,
      length: this.length,
      onClick: this.select
    });
    this.controls = new _controls.default({
      slider: this.slider,
      nextItems: config.nextItems,
      prevItems: config.prevItems,
      next: this.next,
      prev: this.prev
    });
    this.slides = new _slides.default({
      parent: this.list,
      els: config.slides,
      mode: this.mode
    });
    this.autoplay = new _autoplay.default({
      callback: this.next,
      settings: config.autoplay
    });
    this.autoplay.start();
    this.animation = new _animation.default(this.list);
    window.addEventListener('resize', this.onResize); // this.slider.setAttribute('tabindex', 0);

    this.slider.addEventListener('focus', this.onFocus);
    this.slider.addEventListener('blur', this.onBlur);
    this.af.onNextRead(this.tick);
    this.select(this.index, true);
  }

  _createClass(OpSlider, [{
    key: "onFocus",
    value: function onFocus() {
      console.log('focused');
    }
  }, {
    key: "onBlur",
    value: function onBlur() {
      console.log('Blured');
    }
  }, {
    key: "onResize",
    value: function onResize() {
      var scope = this;
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(function () {
        scope.af.onNextRead(scope.tick);
        scope.select(scope.index);
      }, 250);
    }
  }, {
    key: "tick",
    value: function tick() {
      this.rect = this.frame.getBoundingClientRect();
      this.slides.tick(this.rect.width);
      this.xMin = this._calcX(this.length - 1);
      this.xMax = this._calcX(0);
    }
  }, {
    key: "_calcX",
    value: function _calcX(index) {
      var s = this.slides,
          r = this.rect;
      var x = 0,
          xFillFrame = r.width - s.widthSum;

      if (this.mode.centered) {
        x = r.width / 2 - s.rects[index].width / 2;
      }

      if (this.mode.infinite) {
        x -= this.slides.clones.left.width;
      }

      for (var i = 0; i < index; i++) {
        x -= s.rects[i].width;

        if (this.mode.fill && x < xFillFrame) {
          x = xFillFrame;
          this.indexMax = i + 1;
          break;
        }
      }

      return x;
    }
  }, {
    key: "onDown",
    value: function onDown() {
      this.autoplay.stop();
    }
  }, {
    key: "onMove",
    value: function onMove() {
      var e = this.events,
          l = this.length;

      var x = e.mouse.xDist + this._calcX(this.index);

      this.x = this._resist(x);
      this.animation.drag(this.x);

      if (this.mode.updateDotsOnDrag) {
        var index = this.slides.closestSlide(e.mouse.xDist, this.index, e.mouse.xDist > 0);
        var max = this.mode.fill ? this.indexMax : l - 1;
        var min = 0;

        if (index < min) {
          index = this.mode.infinite ? l + index : min;
        } else if (index > max) {
          index = this.mode.infinite ? index - l : max;
        }

        this.dots.select(index);
      }
    }
  }, {
    key: "_resist",
    value: function _resist(x) {
      if (this.mode.infinite) return x;

      if (x > this.xMax) {
        return this.xMax + Math.sqrt(Math.abs(x - this.xMax)) * 4;
      } else if (x < this.xMin) {
        return this.xMin - Math.sqrt(Math.abs(x - this.xMin)) * 4;
      } else {
        return x;
      }
    }
  }, {
    key: "onUp",
    value: function onUp() {
      if (this.events.mouse.xDist > 50) {
        this.prev(true);
      } else if (this.events.mouse.xDist < -50) {
        this.next(true);
      } else {
        this.select(this.index);
      }
    }
  }, {
    key: "prev",
    value: function prev() {
      var dragged = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var index = this.index - 1;

      if (this.mode.multiple & dragged) {
        index = this.slides.closestSlide(this.events.mouse.xDist, this.index, true);
      }

      if (this.mode.infinite || this.mode.loop) {
        if (index < 0) {
          index = this.length - Math.abs(index % this.length);
          if (this.mode.infinite) this.animation.offset(this.slides.widthSum);
        }
      } else index = Math.max(index, 0);

      this.select(index);
    }
  }, {
    key: "next",
    value: function next() {
      var dragged = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var index = this.index + 1;

      if (this.mode.multiple & dragged) {
        index = this.slides.closestSlide(this.events.mouse.xDist, this.index, false);
      }

      if (this.mode.infinite || this.mode.loop) {
        if (index > this.length - 1) {
          index = index % this.length;
          if (this.mode.infinite) this.animation.offset(-this.slides.widthSum);
        }
      } else index = Math.min(index, this.length - 1);

      this.select(index);
    }
  }, {
    key: "select",
    value: function select(index) {
      var _this = this;

      var instant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.af.onNextWrite(function () {
        _this.index = index;

        if (_this.mode.fill) {
          _this.index = Math.min(index, _this.indexMax);
        }

        _this.x = _this._calcX(_this.index);

        _this.dots.select(_this.index);

        _this.slides.select(_this.index);

        if (!_this.mode.infinite) {
          var max = _this.mode.fill ? _this.indexMax : _this.length - 1;
          var min = 0;
          var showNext = _this.index < max,
              showPrev = _this.index > min;

          _this.controls.update(showNext, showPrev);
        }

        if (instant) _this.animation.jump(_this.x);else _this.animation.release(_this.x);

        _this.autoplay.restart();
      });
    }
  }]);

  return OpSlider;
}();

exports.default = OpSlider;

/***/ }),

/***/ "./mysite/resources/js/components/webgl/App.js":
/*!*****************************************************!*\
  !*** ./mysite/resources/js/components/webgl/App.js ***!
  \*****************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

__webpack_require__(/*! core-js/modules/es6.object.define-property */ "./node_modules/core-js/modules/es6.object.define-property.js");

var _three = __webpack_require__(/*! three */ "./node_modules/three/build/three.module.js");

var _af = __webpack_require__(/*! @gladeye/af */ "./node_modules/@gladeye/af/dist/af.umd.js");

var _plain = _interopRequireDefault(__webpack_require__(/*! ~/shaders/plain.frag */ "./mysite/resources/shaders/plain.frag"));

var _plain2 = _interopRequireDefault(__webpack_require__(/*! ~/shaders/plain.vert */ "./mysite/resources/shaders/plain.vert"));

var _bg = _interopRequireDefault(__webpack_require__(/*! ~/images/bg-8.jpg */ "./mysite/resources/images/bg-8.jpg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var App = function App() {
  var _this = this;

  _classCallCheck(this, App);

  _defineProperty(this, "calcSize", function () {
    var _window = window,
        h = _window.innerHeight;
    var w = _this.fixedEl.clientWidth;
    var iw = 2048,
        ih = 700;
    var winRatio = w / h;
    var imageRatio = iw / ih;
    var width = 1;
    var height = 1;
    var scaleX = w / iw;
    var scaleY = h / ih; // console.log(scaleX, scaleY)

    if (winRatio > imageRatio) height = h / ih / scaleX;else width = w / iw / scaleY;
    console.log(width, height);
    _this.mesh.material.uniforms.size.value.x = width;
    _this.mesh.material.uniforms.size.value.y = height;
  });

  _defineProperty(this, "resize", function () {
    var _window2 = window,
        h = _window2.innerHeight;
    var w = _this.fixedEl.clientWidth;
    _this.mesh.material.uniforms.res.value.x = w;
    _this.mesh.material.uniforms.res.value.y = h;

    _this.calcSize();

    _this.renderer.setSize(w, h);
  });

  _defineProperty(this, "draw", function () {
    var t = window.performance.now();
    var _window3 = window,
        pageYOffset = _window3.pageYOffset; // this.mesh.position.y = pageYOffset*0.1;

    _this.mesh.material.uniforms.time.value = t;

    _this.renderer.render(_this.scene, _this.cam);
  });

  var el = document.querySelector('[bg-moving-canvas]');
  console.log(el);
  if (typeof el === 'undefined' || el === null) return;
  this.fixedEl = document.querySelector('[bg-moving-fixed]');
  var _window4 = window,
      _h = _window4.innerHeight,
      _w = _window4.innerWidth;
  this.renderer = new _three.WebGLRenderer({
    canvas: el
  });
  this.renderer.setPixelRatio(1);
  this.scene = new _three.Scene();
  this.cam = new _three.OrthographicCamera(_w / -2, _w / 2, _h / 2, _h / -2, 1, 1000);
  this.cam.position.z = 1;
  var geo = new _three.PlaneGeometry(_w, _h);
  var mat = new _three.ShaderMaterial({
    fragmentShader: _plain.default,
    vertexShader: _plain2.default,
    uniforms: {
      time: {
        value: window.performance.now()
      },
      tDiffuse: {
        value: null
      },
      res: {
        value: new _three.Vector2(_w, _h)
      },
      size: {
        value: new _three.Vector2(_w, _h)
      }
    }
  });
  this.mesh = new _three.Mesh(geo, mat);
  this.scene.add(this.mesh);
  this.af = (0, _af.af)();
  this.af.addWrite(this.draw);
  var loader = new _three.TextureLoader();
  loader.load(_bg.default, function (tex) {
    _this.mesh.material.uniforms.tDiffuse.value = tex;
  });
  this.resize();
  window.addEventListener('resize', this.resize);
};

var _default = App;
exports.default = _default;

/***/ }),

/***/ "./mysite/resources/js/components/window-height.js":
/*!*********************************************************!*\
  !*** ./mysite/resources/js/components/window-height.js ***!
  \*********************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

__webpack_require__(/*! core-js/modules/es6.object.define-property */ "./node_modules/core-js/modules/es6.object.define-property.js");

__webpack_require__(/*! core-js/modules/web.dom.iterable */ "./node_modules/core-js/modules/web.dom.iterable.js");

__webpack_require__(/*! core-js/modules/es6.array.for-each */ "./node_modules/core-js/modules/es6.array.for-each.js");

__webpack_require__(/*! core-js/modules/es6.function.bind */ "./node_modules/core-js/modules/es6.function.bind.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var WindowHeight =
/*#__PURE__*/
function () {
  function WindowHeight(props) {
    _classCallCheck(this, WindowHeight);

    _defineProperty(this, "oldWinHeight", 0);

    _defineProperty(this, "resizeTimer", null);

    this.els = [].slice.call(document.querySelectorAll('[window-height]'));
    this.handleResize = this.handleResize.bind(this);
    this.setSize = this.setSize.bind(this);
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  }

  _createClass(WindowHeight, [{
    key: "handleResize",
    value: function handleResize() {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(this.setSize, 250);
    }
  }, {
    key: "setSize",
    value: function setSize() {
      var winHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

      if (winHeight !== 0 && Math.abs(this.oldWinHeight - winHeight) > 100) {
        this.els.forEach(function (el) {
          el.style.height = winHeight + 'px';
        });
        this.oldWinHeight = winHeight;
      }
    }
  }]);

  return WindowHeight;
}();

exports.default = WindowHeight;

/***/ }),

/***/ "./mysite/resources/js/controllers recursive \\.js$":
/*!***********************************************!*\
  !*** ./mysite/resources/js/controllers \.js$ ***!
  \***********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./accordion_controller.js": "./mysite/resources/js/controllers/accordion_controller.js",
	"./applications-form_controller.js": "./mysite/resources/js/controllers/applications-form_controller.js",
	"./contact-form_controller.js": "./mysite/resources/js/controllers/contact-form_controller.js",
	"./footer_controller.js": "./mysite/resources/js/controllers/footer_controller.js",
	"./gallery_controller.js": "./mysite/resources/js/controllers/gallery_controller.js",
	"./header_controller.js": "./mysite/resources/js/controllers/header_controller.js",
	"./homepage_controller.js": "./mysite/resources/js/controllers/homepage_controller.js",
	"./masonry_controller.js": "./mysite/resources/js/controllers/masonry_controller.js",
	"./nav_controller.js": "./mysite/resources/js/controllers/nav_controller.js",
	"./opinview_controller.js": "./mysite/resources/js/controllers/opinview_controller.js",
	"./opparallax_controller.js": "./mysite/resources/js/controllers/opparallax_controller.js",
	"./slider_controller.js": "./mysite/resources/js/controllers/slider_controller.js",
	"./sticky_controller.js": "./mysite/resources/js/controllers/sticky_controller.js",
	"./window-height_controller.js": "./mysite/resources/js/controllers/window-height_controller.js"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./mysite/resources/js/controllers recursive \\.js$";

/***/ }),

/***/ "./mysite/resources/js/controllers/accordion_controller.js":
/*!*****************************************************************!*\
  !*** ./mysite/resources/js/controllers/accordion_controller.js ***!
  \*****************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

__webpack_require__(/*! core-js/modules/es7.symbol.async-iterator */ "./node_modules/core-js/modules/es7.symbol.async-iterator.js");

__webpack_require__(/*! core-js/modules/es6.symbol */ "./node_modules/core-js/modules/es6.symbol.js");

__webpack_require__(/*! core-js/modules/es6.object.define-property */ "./node_modules/core-js/modules/es6.object.define-property.js");

__webpack_require__(/*! core-js/modules/es6.object.create */ "./node_modules/core-js/modules/es6.object.create.js");

__webpack_require__(/*! core-js/modules/es6.object.set-prototype-of */ "./node_modules/core-js/modules/es6.object.set-prototype-of.js");

__webpack_require__(/*! core-js/modules/es6.function.bind */ "./node_modules/core-js/modules/es6.function.bind.js");

var _stimulus = __webpack_require__(/*! stimulus */ "./node_modules/stimulus/index.js");

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CLASS_OPEN = 'is-item-open';

var _default =
/*#__PURE__*/
function (_Controller) {
  _inherits(_default, _Controller);

  function _default() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(_default)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "opened", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "resizeTimer", null);

    return _this;
  }

  _createClass(_default, [{
    key: "initialize",
    value: function initialize() {
      this.onResize = this.onResize.bind(this);
      this.tick = this.tick.bind(this);
    }
  }, {
    key: "connect",
    value: function connect() {
      window.addEventListener("load", this.tick);
      window.addEventListener("resize", this.onResize);
    }
  }, {
    key: "onResize",
    value: function onResize() {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(this.tick, 100);
    }
  }, {
    key: "tick",
    value: function tick() {
      var rect = this.contentTarget.getBoundingClientRect();
      console.log(rect.height);
      this.bodyTarget.style.height = "".concat(rect.height, "px");
    }
  }, {
    key: "toggle",
    value: function toggle() {
      if (this.opened) {
        this.opened = false;
        this.element.classList.remove(CLASS_OPEN);
      } else {
        this.opened = true;
        this.element.classList.add(CLASS_OPEN);
      }
    }
  }]);

  return _default;
}(_stimulus.Controller);

exports.default = _default;

_defineProperty(_default, "targets", ["body", "content"]);

/***/ }),

/***/ "./mysite/resources/js/controllers/applications-form_controller.js":
/*!*************************************************************************!*\
  !*** ./mysite/resources/js/controllers/applications-form_controller.js ***!
  \*************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

__webpack_require__(/*! core-js/modules/es7.symbol.async-iterator */ "./node_modules/core-js/modules/es7.symbol.async-iterator.js");

__webpack_require__(/*! core-js/modules/es6.symbol */ "./node_modules/core-js/modules/es6.symbol.js");

__webpack_require__(/*! core-js/modules/es6.object.define-property */ "./node_modules/core-js/modules/es6.object.define-property.js");

__webpack_require__(/*! core-js/modules/es6.object.create */ "./node_modules/core-js/modules/es6.object.create.js");

__webpack_require__(/*! core-js/modules/es6.object.set-prototype-of */ "./node_modules/core-js/modules/es6.object.set-prototype-of.js");

__webpack_require__(/*! core-js/modules/web.dom.iterable */ "./node_modules/core-js/modules/web.dom.iterable.js");

__webpack_require__(/*! core-js/modules/es6.array.for-each */ "./node_modules/core-js/modules/es6.array.for-each.js");

__webpack_require__(/*! core-js/modules/es6.function.bind */ "./node_modules/core-js/modules/es6.function.bind.js");

var _stimulus = __webpack_require__(/*! stimulus */ "./node_modules/stimulus/index.js");

var _validate = _interopRequireDefault(__webpack_require__(/*! validate.js */ "./node_modules/validate.js/validate.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CLASS_NOT_VALID = 'mail-is-not-valid';
var CLASS_HAS_VALUE = 'has-value';
var CLASS_MSG_ACTIVE = 'is-msg-active';
var CLASS_IS_FOCUSED = 'is-focused';

var _default =
/*#__PURE__*/
function (_Controller) {
  _inherits(_default, _Controller);

  function _default() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(_default)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "inputItems", []);

    return _this;
  }

  _createClass(_default, [{
    key: "initialize",
    value: function initialize() {
      this.submit = this.submit.bind(this);
      this.sendSuccess = this.sendSuccess.bind(this);
      this.sendError = this.sendError.bind(this);
    }
  }, {
    key: "connect",
    value: function connect() {
      var _this2 = this;

      this.submitSpinnerTarget.style.display = 'none';
      this.url = this.element.getAttribute('action');
      this.element.addEventListener('submit', this.submit);
      this.inputItemTargets.forEach(function (itemTarget) {
        var input = itemTarget.querySelector('input');
        var required = input.getAttribute('required');
        var type = input.getAttribute('data-type');
        var item = {
          self: itemTarget,
          input: input,
          required: required,
          type: type,
          valid: true
        };

        _this2.inputItems.push(item);

        input.addEventListener('focus', function (e) {
          itemTarget.classList.add(CLASS_IS_FOCUSED);
        });
        input.addEventListener('blur', function (e) {
          itemTarget.classList.remove(CLASS_IS_FOCUSED);

          if (item.input.value !== '') {
            itemTarget.classList.add(CLASS_HAS_VALUE);

            _this2.validateValue(item);
          } else {
            itemTarget.classList.remove(CLASS_HAS_VALUE);
          }
        });
        input.addEventListener('input', function (e) {
          if (!item.valid) {
            _this2.validateValue(item);
          }
        });
      });
    }
  }, {
    key: "submit",
    value: function submit(e) {
      e.preventDefault();
      this.msgTarget.classList.add(CLASS_MSG_ACTIVE);

      if (!this.validateAll()) {
        this.msgWrapTarget.innerHTML = "<p>Please fix errors above</p>";
        return;
      } else {
        this.sendData();
        return false;
      }
    }
  }, {
    key: "sendData",
    value: function sendData() {
      var _this3 = this;

      this.submitSpinnerTarget.style.display = '';
      this.newsletterTarget.style.display = 'none';
      var data = new FormData(this.element);
      fetch(this.url, {
        method: 'post',
        body: data,
        headers: {
          'Accept': 'application/json',
          'x-requested-with': 'XMLHttpRequest'
        }
      }).then(function (response) {
        _this3.sendSuccess();
      });
    }
  }, {
    key: "sendSuccess",
    value: function sendSuccess() {
      this.submitSpinnerTarget.style.display = 'none';
      this.msgWrapTarget.innerHTML = "<p>Thanks!<br> You're all signed up.<p>";
    }
  }, {
    key: "sendError",
    value: function sendError() {}
  }, {
    key: "validateAll",
    value: function validateAll() {
      var _this4 = this;

      var isValid = true;
      this.inputItems.forEach(function (item) {
        var notValid = _this4.validateValue(item);

        if (notValid) {
          isValid = false;
        }
      });
      return isValid;
    }
  }, {
    key: "validateValue",
    value: function validateValue(item) {
      var target = item.self;
      var value = item.input.value;
      var required = item.required;
      var type = item.type;
      var constraints = {
        'field': {}
      };

      if (required !== null) {
        constraints.field.presence = {
          allowEmpty: false
        };
      }

      if (type === 'email') {
        constraints.field.email = true;
      }

      var notValid = (0, _validate.default)({
        field: value
      }, constraints);

      if (notValid) {
        item.valid = false;
        target.classList.add(CLASS_NOT_VALID);
      } else {
        item.valid = true;
        target.classList.remove(CLASS_NOT_VALID);
      }

      return notValid;
    }
  }]);

  return _default;
}(_stimulus.Controller);

exports.default = _default;

_defineProperty(_default, "targets", ['inputItem', 'msg', 'msgWrap', 'newsletter', 'submitSpinner', 'submitBtn']);

/***/ }),

/***/ "./mysite/resources/js/controllers/contact-form_controller.js":
/*!********************************************************************!*\
  !*** ./mysite/resources/js/controllers/contact-form_controller.js ***!
  \********************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

__webpack_require__(/*! core-js/modules/es7.symbol.async-iterator */ "./node_modules/core-js/modules/es7.symbol.async-iterator.js");

__webpack_require__(/*! core-js/modules/es6.symbol */ "./node_modules/core-js/modules/es6.symbol.js");

__webpack_require__(/*! core-js/modules/es6.object.define-property */ "./node_modules/core-js/modules/es6.object.define-property.js");

__webpack_require__(/*! core-js/modules/es6.object.create */ "./node_modules/core-js/modules/es6.object.create.js");

__webpack_require__(/*! core-js/modules/es6.object.set-prototype-of */ "./node_modules/core-js/modules/es6.object.set-prototype-of.js");

__webpack_require__(/*! core-js/modules/web.dom.iterable */ "./node_modules/core-js/modules/web.dom.iterable.js");

__webpack_require__(/*! core-js/modules/es6.array.for-each */ "./node_modules/core-js/modules/es6.array.for-each.js");

__webpack_require__(/*! core-js/modules/es6.function.bind */ "./node_modules/core-js/modules/es6.function.bind.js");

var _stimulus = __webpack_require__(/*! stimulus */ "./node_modules/stimulus/index.js");

var _validate = _interopRequireDefault(__webpack_require__(/*! validate.js */ "./node_modules/validate.js/validate.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CLASS_NOT_VALID = 'is-not-valid';
var CLASS_HAS_VALUE = 'has-value';
var CLASS_IS_FOCUSED = 'is-focused';
var CLASS_MSG_ACTIVE = 'is-msg-active';

var _default =
/*#__PURE__*/
function (_Controller) {
  _inherits(_default, _Controller);

  function _default() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(_default)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "inputItems", []);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "checkItems", []);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "textItems", []);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "url", "");

    return _this;
  }

  _createClass(_default, [{
    key: "initialize",
    value: function initialize() {
      this.submit = this.submit.bind(this);
      this.sendSuccess = this.sendSuccess.bind(this);
      this.sendError = this.sendError.bind(this);
    }
  }, {
    key: "connect",
    value: function connect() {
      var _this2 = this;

      this.url = this.element.getAttribute('action');
      this.element.addEventListener('submit', this.submit);
      this.inputItemTargets.forEach(function (itemTarget) {
        var input = itemTarget.querySelector('input');
        var required = input.getAttribute('required');
        var type = input.getAttribute('data-type');
        var item = {
          self: itemTarget,
          input: input,
          required: required,
          type: type,
          valid: true
        };

        _this2.inputItems.push(item);

        input.addEventListener('focus', function (e) {
          itemTarget.classList.add(CLASS_IS_FOCUSED);
        });
        input.addEventListener('blur', function (e) {
          itemTarget.classList.remove(CLASS_IS_FOCUSED);

          if (item.input.value !== '') {
            itemTarget.classList.add(CLASS_HAS_VALUE);

            _this2.validateValue(item);
          } else {
            itemTarget.classList.remove(CLASS_HAS_VALUE);
          }
        });
        input.addEventListener('input', function (e) {
          if (!item.valid) {
            // console.log('not valid');
            _this2.validateValue(item);
          }
        });
      });
      this.checkItemTargets.forEach(function (item) {
        var input = item.querySelector('input');

        _this2.checkItems.push({
          self: item,
          input: input
        });
      });
      this.textItemTargets.forEach(function (item) {
        var textarea = item.querySelector('textarea');

        _this2.textItems.push({
          self: item,
          textarea: textarea
        });
      });
    }
  }, {
    key: "submit",
    value: function submit(e) {
      e.preventDefault();
      this.msgTarget.classList.add(CLASS_MSG_ACTIVE);

      if (!this.validateAll()) {
        this.msgWrapTarget.innerHTML = "<p>Please fix errors above</p>";
        return;
      } else {
        this.sendData();
      }
    }
  }, {
    key: "sendData",
    value: function sendData() {
      var _this3 = this;

      var data = new FormData(this.element);
      fetch(this.url, {
        method: 'post',
        body: data,
        headers: {
          'Accept': 'application/json',
          'x-requested-with': 'XMLHttpRequest'
        }
      }).then(function (response) {
        _this3.sendSuccess();

        console.log('response', response);
      });
    }
  }, {
    key: "sendSuccess",
    value: function sendSuccess() {
      this.clearAll();
      console.log('sendSuccess', this.msgWrapTarget);
      this.msgWrapTarget.innerHTML = "<p><strong>Thank you for your message.</strong><br/>We will get back to as soon as possible.</p><a href=\"/\">Return to Home</a>";
    }
  }, {
    key: "sendError",
    value: function sendError() {}
  }, {
    key: "clearAll",
    value: function clearAll() {
      this.inputItems.forEach(function (item) {
        item.input.value = '';
      });
      this.checkItems.forEach(function (item) {
        item.input.checked = false;
      });
      this.textItems.forEach(function (item) {
        item.textarea.value = '';
      });
    }
  }, {
    key: "validateAll",
    value: function validateAll() {
      var _this4 = this;

      console.log('Validate all', isValid);
      var isValid = true;
      this.inputItems.forEach(function (item) {
        var notValid = _this4.validateValue(item);

        if (notValid) {
          item.self.scrollIntoView();
          isValid = false;
        }
      });
      return isValid;
    }
  }, {
    key: "validateValue",
    value: function validateValue(item) {
      var target = item.self;
      var value = item.input.value;
      var required = item.required;
      var type = item.type; // console.log('validateValue');

      var constraints = {
        'field': {}
      };

      if (required !== null) {
        constraints.field.presence = {
          allowEmpty: false
        };
      }

      if (type === 'email') {
        constraints.field.email = true;
      }

      var notValid = (0, _validate.default)({
        field: value
      }, constraints);

      if (notValid) {
        item.valid = false;
        target.classList.add(CLASS_NOT_VALID);
      } else {
        item.valid = true;
        target.classList.remove(CLASS_NOT_VALID);
      } // console.log(notValid);


      return notValid;
    }
  }]);

  return _default;
}(_stimulus.Controller);

exports.default = _default;

_defineProperty(_default, "targets", ['inputItem', 'checkItem', 'textItem', 'msg', 'msgWrap']);

/***/ }),

/***/ "./mysite/resources/js/controllers/footer_controller.js":
/*!**************************************************************!*\
  !*** ./mysite/resources/js/controllers/footer_controller.js ***!
  \**************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

__webpack_require__(/*! core-js/modules/es7.symbol.async-iterator */ "./node_modules/core-js/modules/es7.symbol.async-iterator.js");

__webpack_require__(/*! core-js/modules/es6.symbol */ "./node_modules/core-js/modules/es6.symbol.js");

__webpack_require__(/*! core-js/modules/es6.object.define-property */ "./node_modules/core-js/modules/es6.object.define-property.js");

__webpack_require__(/*! core-js/modules/es6.object.create */ "./node_modules/core-js/modules/es6.object.create.js");

__webpack_require__(/*! core-js/modules/es6.object.set-prototype-of */ "./node_modules/core-js/modules/es6.object.set-prototype-of.js");

__webpack_require__(/*! core-js/modules/es6.function.bind */ "./node_modules/core-js/modules/es6.function.bind.js");

var _stimulus = __webpack_require__(/*! stimulus */ "./node_modules/stimulus/index.js");

var _AF = _interopRequireDefault(__webpack_require__(/*! ./../helpers/AF */ "./mysite/resources/js/helpers/AF.js"));

var _rect = __webpack_require__(/*! ./../helpers/rect */ "./mysite/resources/js/helpers/rect.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default =
/*#__PURE__*/
function (_Controller) {
  _inherits(_default, _Controller);

  function _default() {
    _classCallCheck(this, _default);

    return _possibleConstructorReturn(this, _getPrototypeOf(_default).apply(this, arguments));
  }

  _createClass(_default, [{
    key: "initialize",
    value: function initialize() {
      this.handleResize = this.handleResize.bind(this);
      this.af = _AF.default.instance();
      this.read = this.read.bind(this);
      this.write = this.write.bind(this);
    }
  }, {
    key: "connect",
    value: function connect() {
      // window.addEventListener('resize', this.handleResize);
      // this.handleResize();
      this.rect = new _rect.Rect({
        el: this.element
      });
    }
  }, {
    key: "read",
    value: function read() {
      this.rect.tick();
    }
  }, {
    key: "write",
    value: function write() {
      for (var i = this.children.length - 1; i >= 0; i--) {
        this.children[i].animate(this.rect.progress);
      }
    }
  }, {
    key: "handleResize",
    value: function handleResize() {
      var rect = this.innerTarget.getBoundingClientRect();
      this.height = rect.height;
      this.element.style.height = this.height + 'px';
    }
  }]);

  return _default;
}(_stimulus.Controller);

exports.default = _default;

_defineProperty(_default, "targets", ['inner']);

/***/ }),

/***/ "./mysite/resources/js/controllers/gallery_controller.js":
/*!***************************************************************!*\
  !*** ./mysite/resources/js/controllers/gallery_controller.js ***!
  \***************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

__webpack_require__(/*! core-js/modules/es7.symbol.async-iterator */ "./node_modules/core-js/modules/es7.symbol.async-iterator.js");

__webpack_require__(/*! core-js/modules/es6.symbol */ "./node_modules/core-js/modules/es6.symbol.js");

__webpack_require__(/*! core-js/modules/es6.object.define-property */ "./node_modules/core-js/modules/es6.object.define-property.js");

__webpack_require__(/*! core-js/modules/es6.object.create */ "./node_modules/core-js/modules/es6.object.create.js");

__webpack_require__(/*! core-js/modules/es6.object.set-prototype-of */ "./node_modules/core-js/modules/es6.object.set-prototype-of.js");

__webpack_require__(/*! core-js/modules/es6.function.bind */ "./node_modules/core-js/modules/es6.function.bind.js");

__webpack_require__(/*! core-js/modules/web.dom.iterable */ "./node_modules/core-js/modules/web.dom.iterable.js");

__webpack_require__(/*! core-js/modules/es6.array.for-each */ "./node_modules/core-js/modules/es6.array.for-each.js");

var _stimulus = __webpack_require__(/*! stimulus */ "./node_modules/stimulus/index.js");

var _galleryModal = _interopRequireDefault(__webpack_require__(/*! ./../components/gallery-modal */ "./mysite/resources/js/components/gallery-modal.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default =
/*#__PURE__*/
function (_Controller) {
  _inherits(_default, _Controller);

  function _default() {
    _classCallCheck(this, _default);

    return _possibleConstructorReturn(this, _getPrototypeOf(_default).apply(this, arguments));
  }

  _createClass(_default, [{
    key: "initialize",
    value: function initialize() {
      this.galleryModal = _galleryModal.default.instance();
    }
  }, {
    key: "connect",
    value: function connect() {
      var _this = this;

      this.itemTargets.forEach(function (item, index) {
        var caption = _this.captionTargets[index] ? _this.captionTargets[index].innerHTML : null;
        var imgSrc = item.getAttribute('gallery-item');
        item.addEventListener('click', _this.onClick.bind(_this, index));

        _this.galleryModal.createItem(index, imgSrc, caption);
      });
    }
  }, {
    key: "onClick",
    value: function onClick(index) {
      this.galleryModal.open(index);
    }
  }]);

  return _default;
}(_stimulus.Controller);

exports.default = _default;

_defineProperty(_default, "targets", ['item', 'caption']);

/***/ }),

/***/ "./mysite/resources/js/controllers/header_controller.js":
/*!**************************************************************!*\
  !*** ./mysite/resources/js/controllers/header_controller.js ***!
  \**************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

__webpack_require__(/*! core-js/modules/es7.symbol.async-iterator */ "./node_modules/core-js/modules/es7.symbol.async-iterator.js");

__webpack_require__(/*! core-js/modules/es6.symbol */ "./node_modules/core-js/modules/es6.symbol.js");

__webpack_require__(/*! core-js/modules/es6.object.define-property */ "./node_modules/core-js/modules/es6.object.define-property.js");

__webpack_require__(/*! core-js/modules/es6.object.create */ "./node_modules/core-js/modules/es6.object.create.js");

__webpack_require__(/*! core-js/modules/es6.object.set-prototype-of */ "./node_modules/core-js/modules/es6.object.set-prototype-of.js");

__webpack_require__(/*! core-js/modules/es6.function.bind */ "./node_modules/core-js/modules/es6.function.bind.js");

var _stimulus = __webpack_require__(/*! stimulus */ "./node_modules/stimulus/index.js");

var _opInview = _interopRequireDefault(__webpack_require__(/*! ./../components/opInview/opInview */ "./mysite/resources/js/components/opInview/opInview.js"));

var _animejs = _interopRequireDefault(__webpack_require__(/*! animejs */ "./node_modules/animejs/anime.min.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default =
/*#__PURE__*/
function (_Controller) {
  _inherits(_default, _Controller);

  function _default() {
    _classCallCheck(this, _default);

    return _possibleConstructorReturn(this, _getPrototypeOf(_default).apply(this, arguments));
  }

  _createClass(_default, [{
    key: "initialize",
    value: function initialize() {
      this.activate = this.activate.bind(this);
    }
  }, {
    key: "connect",
    value: function connect() {
      // let words = this.hTarget.textContent.trim().split(" ");
      // let content = '';
      // for (let i = 0; i < words.length; i++) {
      //     content += `<span class='word'>${words[i]}</span> `;
      // }
      // this.hTarget.innerHTML = content;
      new _opInview.default(this.element, {
        start: 0.2,
        end: 0.8,
        activateCallback: this.activate
      });
    }
  }, {
    key: "activate",
    value: function activate() {// this.animationText = anime.timeline({
      //     autoplay: true
      // }).add({
      //     targets: this.hTarget.querySelectorAll('.word'),
      //     opacity: [0, 1],
      //     translateY: {
      //         value: [20, 0],
      //         easing: "easeOutExpo",
      //     },
      //     easing: "easeOutQuad",
      //     duration: 1000,
      //     // duration: function() { return anime.random(1000, 1400); },
      //     delay: function(el, i) {
      //         return 100 * (i+1)
      //     },
      // });
      // if (this.subTarget) {
      //     this.animationText.add({
      //         targets: this.subTarget,
      //         opacity: {
      //             value: [0, 1],
      //             easing: "easeInOutQuad",
      //         },
      //         translateY: [50, 0],
      //         easing: "easeOutQuad",
      //         duration: 1200,
      //         offset: 0,
      //         delay: 800
      //     });
      // }
    }
  }]);

  return _default;
}(_stimulus.Controller);

exports.default = _default;

_defineProperty(_default, "targets", ['h']);

/***/ }),

/***/ "./mysite/resources/js/controllers/homepage_controller.js":
/*!****************************************************************!*\
  !*** ./mysite/resources/js/controllers/homepage_controller.js ***!
  \****************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

__webpack_require__(/*! core-js/modules/es7.symbol.async-iterator */ "./node_modules/core-js/modules/es7.symbol.async-iterator.js");

__webpack_require__(/*! core-js/modules/es6.symbol */ "./node_modules/core-js/modules/es6.symbol.js");

__webpack_require__(/*! core-js/modules/es6.object.define-property */ "./node_modules/core-js/modules/es6.object.define-property.js");

__webpack_require__(/*! core-js/modules/es6.object.create */ "./node_modules/core-js/modules/es6.object.create.js");

__webpack_require__(/*! core-js/modules/es6.object.set-prototype-of */ "./node_modules/core-js/modules/es6.object.set-prototype-of.js");

__webpack_require__(/*! core-js/modules/es6.function.bind */ "./node_modules/core-js/modules/es6.function.bind.js");

var _stimulus = __webpack_require__(/*! stimulus */ "./node_modules/stimulus/index.js");

var _opInview = _interopRequireDefault(__webpack_require__(/*! ./../components/opInview/opInview */ "./mysite/resources/js/components/opInview/opInview.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CLASS_BG_LIGHT = 'is-bg-light';

var _default =
/*#__PURE__*/
function (_Controller) {
  _inherits(_default, _Controller);

  function _default() {
    _classCallCheck(this, _default);

    return _possibleConstructorReturn(this, _getPrototypeOf(_default).apply(this, arguments));
  }

  _createClass(_default, [{
    key: "initialize",
    value: function initialize() {
      this.switchToDark = this.switchToDark.bind(this);
      this.switchToLight = this.switchToLight.bind(this);
    }
  }, {
    key: "connect",
    value: function connect() {
      this.mainInview = new _opInview.default(this.contentTarget, {
        start: .05,
        end: 2,
        deactivate: true,
        activateCallback: this.switchToLight,
        deactivateCallback: this.switchToDark
      }); // console.log("Hello, Stimulus!", element);
    }
  }, {
    key: "switchToDark",
    value: function switchToDark() {
      this.element.classList.remove(CLASS_BG_LIGHT);
    }
  }, {
    key: "switchToLight",
    value: function switchToLight() {
      this.element.classList.add(CLASS_BG_LIGHT);
    }
  }]);

  return _default;
}(_stimulus.Controller);

exports.default = _default;

_defineProperty(_default, "targets", ['main', 'content']);

/***/ }),

/***/ "./mysite/resources/js/controllers/masonry_controller.js":
/*!***************************************************************!*\
  !*** ./mysite/resources/js/controllers/masonry_controller.js ***!
  \***************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

__webpack_require__(/*! core-js/modules/es7.symbol.async-iterator */ "./node_modules/core-js/modules/es7.symbol.async-iterator.js");

__webpack_require__(/*! core-js/modules/es6.symbol */ "./node_modules/core-js/modules/es6.symbol.js");

__webpack_require__(/*! core-js/modules/es6.object.define-property */ "./node_modules/core-js/modules/es6.object.define-property.js");

__webpack_require__(/*! core-js/modules/es6.object.create */ "./node_modules/core-js/modules/es6.object.create.js");

__webpack_require__(/*! core-js/modules/es6.object.set-prototype-of */ "./node_modules/core-js/modules/es6.object.set-prototype-of.js");

__webpack_require__(/*! core-js/modules/es6.function.bind */ "./node_modules/core-js/modules/es6.function.bind.js");

var _stimulus = __webpack_require__(/*! stimulus */ "./node_modules/stimulus/index.js");

var _masonryLayout = _interopRequireDefault(__webpack_require__(/*! masonry-layout */ "./node_modules/masonry-layout/masonry.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default =
/*#__PURE__*/
function (_Controller) {
  _inherits(_default, _Controller);

  function _default() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(_default)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "resizeTimer", null);

    return _this;
  }

  _createClass(_default, [{
    key: "initialize",
    value: function initialize() {
      this.onResize = this.onResize.bind(this);
    }
  }, {
    key: "connect",
    value: function connect() {
      var _this2 = this;

      window.addEventListener('load', function () {
        _this2.init();
      });
      window.addEventListener('resize', this.onResize);
    }
  }, {
    key: "onResize",
    value: function onResize() {
      var scope = this;
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(function () {
        // Reload layout sizing 
        scope.msnry.destroy();
        scope.init();
      }, 250);
    }
  }, {
    key: "init",
    value: function init() {
      this.msnry = new _masonryLayout.default(this.element, {
        // options...
        columnWidth: '[data-grid-sizer]',
        gutter: '[data-gutter-sizer]',
        itemSelector: '[data-item]',
        percentPosition: true,
        isResizable: true
      });
    }
  }]);

  return _default;
}(_stimulus.Controller);

exports.default = _default;

_defineProperty(_default, "targets", ['item']);

/***/ }),

/***/ "./mysite/resources/js/controllers/nav_controller.js":
/*!***********************************************************!*\
  !*** ./mysite/resources/js/controllers/nav_controller.js ***!
  \***********************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

__webpack_require__(/*! core-js/modules/es7.symbol.async-iterator */ "./node_modules/core-js/modules/es7.symbol.async-iterator.js");

__webpack_require__(/*! core-js/modules/es6.symbol */ "./node_modules/core-js/modules/es6.symbol.js");

__webpack_require__(/*! core-js/modules/es6.object.define-property */ "./node_modules/core-js/modules/es6.object.define-property.js");

__webpack_require__(/*! core-js/modules/es6.object.create */ "./node_modules/core-js/modules/es6.object.create.js");

__webpack_require__(/*! core-js/modules/es6.object.set-prototype-of */ "./node_modules/core-js/modules/es6.object.set-prototype-of.js");

var _stimulus = __webpack_require__(/*! stimulus */ "./node_modules/stimulus/index.js");

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CLASS_OPEN = 'is-fixed-open';

var _default =
/*#__PURE__*/
function (_Controller) {
  _inherits(_default, _Controller);

  function _default() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(_default)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "opened", false);

    return _this;
  }

  _createClass(_default, [{
    key: "connect",
    value: function connect() {}
  }, {
    key: "open",
    value: function open() {
      this.opened = true;
      this.fixedTarget.classList.add(CLASS_OPEN);
      this.burgerTarget.classList.add(CLASS_OPEN);
    }
  }, {
    key: "close",
    value: function close() {
      this.opened = false;
      this.fixedTarget.classList.remove(CLASS_OPEN);
      this.burgerTarget.classList.remove(CLASS_OPEN);
    }
  }, {
    key: "toggle",
    value: function toggle() {
      if (this.opened) this.close();else this.open();
    }
  }]);

  return _default;
}(_stimulus.Controller);

exports.default = _default;

_defineProperty(_default, "targets", ['fixed', 'burger']);

/***/ }),

/***/ "./mysite/resources/js/controllers/opinview_controller.js":
/*!****************************************************************!*\
  !*** ./mysite/resources/js/controllers/opinview_controller.js ***!
  \****************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

__webpack_require__(/*! core-js/modules/es7.symbol.async-iterator */ "./node_modules/core-js/modules/es7.symbol.async-iterator.js");

__webpack_require__(/*! core-js/modules/es6.symbol */ "./node_modules/core-js/modules/es6.symbol.js");

__webpack_require__(/*! core-js/modules/es6.object.define-property */ "./node_modules/core-js/modules/es6.object.define-property.js");

__webpack_require__(/*! core-js/modules/es6.object.create */ "./node_modules/core-js/modules/es6.object.create.js");

__webpack_require__(/*! core-js/modules/es6.object.set-prototype-of */ "./node_modules/core-js/modules/es6.object.set-prototype-of.js");

__webpack_require__(/*! core-js/modules/es6.regexp.replace */ "./node_modules/core-js/modules/es6.regexp.replace.js");

__webpack_require__(/*! core-js/modules/es6.function.bind */ "./node_modules/core-js/modules/es6.function.bind.js");

var _stimulus = __webpack_require__(/*! stimulus */ "./node_modules/stimulus/index.js");

var _AF = _interopRequireDefault(__webpack_require__(/*! ./../helpers/AF */ "./mysite/resources/js/helpers/AF.js"));

var _rect = __webpack_require__(/*! ./../helpers/rect */ "./mysite/resources/js/helpers/rect.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default =
/*#__PURE__*/
function (_Controller) {
  _inherits(_default, _Controller);

  function _default() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(_default)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "active", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "settings", {
      start: 0.2,
      end: 0.8,
      class: 'is-inview',
      deactivate: false,
      activateCallback: null,
      deactivateCallback: null
    });

    return _this;
  }

  _createClass(_default, [{
    key: "initialize",
    value: function initialize() {
      this.af = _AF.default.instance();
      this.read = this.read.bind(this);
      this.write = this.write.bind(this);
      this.activate = this.activate.bind(this);
      this.deactivate = this.deactivate.bind(this);
    }
  }, {
    key: "connect",
    value: function connect() {
      this.rect = new _rect.Rect({
        el: this.element
      });
      var attr = JSON.parse(this.element.getAttribute('op-inview').replace(/'/g, '"'));
      if (attr.start) this.settings.start = parseFloat(attr.start);
      if (attr.end) this.settings.end = parseFloat(attr.end);
      if (attr.class) this.settings.class = attr.class;
      if (attr.deactivate) this.settings.deactivate = parseInt(attr.deactivate) !== 0;
      this.af.addRead(this.read);
      this.af.addWrite(this.write);
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      this.af.removeRead(this.read);
      this.af.removeWrite(this.write);
    }
  }, {
    key: "read",
    value: function read() {
      this.rect.tick();
    }
  }, {
    key: "write",
    value: function write() {
      if (this.rect.progress >= this.settings.start && this.rect.progress <= this.settings.end) {
        this.activate();
      } else {
        if (this.settings.deactivate) {
          this.deactivate();
        }
      }
    }
  }, {
    key: "activate",
    value: function activate() {
      if (this.active && this.active !== null) return; // console.log('activate');

      this.active = true;
      this.element.classList.add(this.settings.class);

      if (this.settings.activateCallback) {
        this.settings.activateCallback();
      }

      if (!this.settings.deactivate) {
        this.af.removeRead(this.read);
        this.af.removeWrite(this.write);
      }
    }
  }, {
    key: "deactivate",
    value: function deactivate() {
      if (!this.active && this.active !== null) return;
      this.active = false;
      this.element.classList.remove(this.settings.class);

      if (this.settings.deactivateCallback) {
        this.settings.deactivateCallback();
      }
    }
  }]);

  return _default;
}(_stimulus.Controller);

exports.default = _default;

/***/ }),

/***/ "./mysite/resources/js/controllers/opparallax_controller.js":
/*!******************************************************************!*\
  !*** ./mysite/resources/js/controllers/opparallax_controller.js ***!
  \******************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Child = exports.default = void 0;

__webpack_require__(/*! core-js/modules/es6.string.trim */ "./node_modules/core-js/modules/es6.string.trim.js");

__webpack_require__(/*! core-js/modules/es6.regexp.replace */ "./node_modules/core-js/modules/es6.regexp.replace.js");

__webpack_require__(/*! core-js/modules/es7.symbol.async-iterator */ "./node_modules/core-js/modules/es7.symbol.async-iterator.js");

__webpack_require__(/*! core-js/modules/es6.symbol */ "./node_modules/core-js/modules/es6.symbol.js");

__webpack_require__(/*! core-js/modules/es6.object.define-property */ "./node_modules/core-js/modules/es6.object.define-property.js");

__webpack_require__(/*! core-js/modules/es6.object.create */ "./node_modules/core-js/modules/es6.object.create.js");

__webpack_require__(/*! core-js/modules/es6.object.set-prototype-of */ "./node_modules/core-js/modules/es6.object.set-prototype-of.js");

__webpack_require__(/*! core-js/modules/es6.array.map */ "./node_modules/core-js/modules/es6.array.map.js");

__webpack_require__(/*! core-js/modules/es6.function.bind */ "./node_modules/core-js/modules/es6.function.bind.js");

var _stimulus = __webpack_require__(/*! stimulus */ "./node_modules/stimulus/index.js");

var _parseUnit = _interopRequireDefault(__webpack_require__(/*! parse-unit */ "./node_modules/parse-unit/index.js"));

var _isMobile = __webpack_require__(/*! ./../helpers/is-mobile */ "./mysite/resources/js/helpers/is-mobile.js");

var _isIe = __webpack_require__(/*! ./../helpers/is-ie */ "./mysite/resources/js/helpers/is-ie.js");

var _rect = __webpack_require__(/*! ./../helpers/rect */ "./mysite/resources/js/helpers/rect.js");

var _AF = _interopRequireDefault(__webpack_require__(/*! ./../helpers/AF */ "./mysite/resources/js/helpers/AF.js"));

var eases = _interopRequireWildcard(__webpack_require__(/*! ./../helpers/ease-adv */ "./mysite/resources/js/helpers/ease-adv.js"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ATTR_PARALLAX_CHILD = 'op-parallax-child';

var _default =
/*#__PURE__*/
function (_Controller) {
  _inherits(_default, _Controller);

  function _default() {
    _classCallCheck(this, _default);

    return _possibleConstructorReturn(this, _getPrototypeOf(_default).apply(this, arguments));
  }

  _createClass(_default, [{
    key: "initialize",
    value: function initialize() {
      this.af = _AF.default.instance();
      this.read = this.read.bind(this);
      this.write = this.write.bind(this);
    }
  }, {
    key: "connect",
    value: function connect() {
      var _this = this;

      // Disable on Tablets & Mobile
      if (_isMobile.isMobile) return;
      if (_isIe.isIE) return;
      this.rect = new _rect.Rect({
        el: this.element
      });
      this.children = this.childTargets.map(function (childNode) {
        return new Child(childNode);
      });
      this.af.addRead(this.read);
      this.af.addWrite(this.write);
      this.af.onNextWrite(function () {
        _this.element.classList.add('is-parallax-active');
      });
    }
  }, {
    key: "read",
    value: function read() {
      this.rect.tick();
    }
  }, {
    key: "write",
    value: function write() {
      for (var i = this.children.length - 1; i >= 0; i--) {
        this.children[i].animate(this.rect);
      }
    }
  }]);

  return _default;
}(_stimulus.Controller);

exports.default = _default;

_defineProperty(_default, "targets", ['child']);

var Child =
/*#__PURE__*/
function () {
  // Multiplier for smaller values, i.e. opaicty - 0-1
  function Child(el) {
    _classCallCheck(this, Child);

    _defineProperty(this, "start", 0);

    _defineProperty(this, "end", 1);

    _defineProperty(this, "x", null);

    _defineProperty(this, "y", null);

    _defineProperty(this, "scale", null);

    _defineProperty(this, "opacity", null);

    _defineProperty(this, "ease", 'linear');

    _defineProperty(this, "progress", null);

    _defineProperty(this, "smallMult", 1000);

    _defineProperty(this, "magic", 0.5);

    _defineProperty(this, "precise", false);

    _defineProperty(this, "finished", false);

    _defineProperty(this, "alternative", false);

    this.el = el;
    var attr = JSON.parse(this.el.getAttribute(ATTR_PARALLAX_CHILD).replace(/'/g, '"')); // console.log(attr.precise);

    if (attr.start) this.start = parseFloat(attr.start);
    if (attr.end) this.end = parseFloat(attr.end);
    if (attr.y) this.y = this.parse(attr.y);
    if (attr.x) this.x = this.parse(attr.x);
    if (attr.scale) this.scale = this.parse(attr.scale, true);
    if (attr.opacity) this.opacity = this.parse(attr.opacity, true);
    if (attr.magic) this.magic = parseFloat(attr.magic);
    if (attr.ease) this.ease = attr.ease;
    if (attr.precise === 'true') this.precise = true;
    if (attr.alternative === 'true') this.alternative = true;
  }

  _createClass(Child, [{
    key: "animate",
    value: function animate(rect) {
      var progress;

      if (this.alternative) {
        var st = window.pageYOffset;
        var h = rect.height;
        progress = st / h;
      } else {
        progress = rect.progress;
      }

      var cleaned = Math.min(Math.max(progress, this.start), this.end); // start..end

      var percent = (cleaned - this.start) / (this.end - this.start); // 0 .. 1

      this.progress = eases[this.ease](percent); // 0 .. 1 - Eased

      var changed = false;
      if (this.y) changed = this.tick(this.y);
      if (this.x) changed = this.tick(this.x);
      if (this.scale) changed = this.tick(this.scale);
      if (this.opacity) changed = this.tick(this.opacity);

      if (changed) {
        this.render();
      }
    }
  }, {
    key: "tick",
    value: function tick(prop) {
      if (prop) {
        var value = prop.from + prop.distance * this.progress * prop.direction;

        if (this.precise) {
          value = Math.round(value); // If precise - end value needs to be round
        }

        if (prop.last === undefined) {
          prop.last = value;
          return true;
        } else {
          prop.last += (value - prop.last) * this.magic;
        }

        if (Math.abs(prop.last - value) < 0.2) {
          if (this.precise) {
            if (!prop.precise) {
              prop.last = value;
              prop.precise = true;
              return true; // One more iteration to set the value to be precise
            }
          }

          return false; // If new value almost where it needs to be
        }

        prop.precise = false;
        return true;
      }

      return false;
    }
  }, {
    key: "render",
    value: function render() {
      // console.log('render');
      if (this.y || this.x || this.scale) {
        var y = this.y ? this.y.unit === 'vw' || this.y.unit === 'vh' || this.y.unit === '%' ? this.y.last / this.smallMult + this.y.unit : this.y.last + this.y.unit : 0;
        var x = this.x ? this.x.last + this.x.unit : 0;
        var string = '';

        if (this.y || this.x) {
          string += 'translate3d(' + x + ',' + y + ', 0) '; // console.log(string);
        }

        if (this.scale) {
          var scale = this.scale.last / this.smallMult;
          scale = Math.round(scale * 10000) / 10000;
          string += 'scale3d(' + scale + ',' + scale + ',' + scale + ')'; //console.log(string);
        } // console.log(string);


        this.el.style.transform = string.trim();
      }

      if (this.opacity) {
        console.log(this.opacity);
        var opacity = this.opacity.last / this.smallMult;
        opacity = Math.round(opacity * 1000) / 1000;
        this.el.style.opacity = opacity;
      }
    }
  }, {
    key: "parse",
    value: function parse(value) {
      var small = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (!value) return false;
      var prop = {
        unit: (0, _parseUnit.default)(value[0])[1] || '',
        from: (0, _parseUnit.default)(value[0])[0],
        to: (0, _parseUnit.default)(value[1])[0]
      };
      if (prop.unit === 'vw' || prop.unit === 'vh' || prop.unit === '%') small = true;
      if (small) prop.from = prop.from * this.smallMult;
      if (small) prop.to = prop.to * this.smallMult;
      prop.direction = prop.from > prop.to ? -1 : 1;
      prop.distance = Math.abs(prop.from - prop.to);
      prop.precise = true;
      return prop;
    }
  }]);

  return Child;
}();

exports.Child = Child;

/***/ }),

/***/ "./mysite/resources/js/controllers/slider_controller.js":
/*!**************************************************************!*\
  !*** ./mysite/resources/js/controllers/slider_controller.js ***!
  \**************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

__webpack_require__(/*! core-js/modules/es7.symbol.async-iterator */ "./node_modules/core-js/modules/es7.symbol.async-iterator.js");

__webpack_require__(/*! core-js/modules/es6.symbol */ "./node_modules/core-js/modules/es6.symbol.js");

__webpack_require__(/*! core-js/modules/es6.object.define-property */ "./node_modules/core-js/modules/es6.object.define-property.js");

__webpack_require__(/*! core-js/modules/es6.object.create */ "./node_modules/core-js/modules/es6.object.create.js");

__webpack_require__(/*! core-js/modules/es6.object.set-prototype-of */ "./node_modules/core-js/modules/es6.object.set-prototype-of.js");

__webpack_require__(/*! core-js/modules/web.dom.iterable */ "./node_modules/core-js/modules/web.dom.iterable.js");

__webpack_require__(/*! core-js/modules/es6.array.for-each */ "./node_modules/core-js/modules/es6.array.for-each.js");

__webpack_require__(/*! core-js/modules/es6.function.bind */ "./node_modules/core-js/modules/es6.function.bind.js");

var _stimulus = __webpack_require__(/*! stimulus */ "./node_modules/stimulus/index.js");

var _opSlider = _interopRequireDefault(__webpack_require__(/*! ./../components/opSlider/opSlider */ "./mysite/resources/js/components/opSlider/opSlider.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default =
/*#__PURE__*/
function (_Controller) {
  _inherits(_default, _Controller);

  function _default() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(_default)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleMouseOver", function () {
      _this.element.classList.add('is-hovered');
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleMouseOut", function () {
      _this.element.classList.remove('is-hovered');
    });

    return _this;
  }

  _createClass(_default, [{
    key: "initialize",
    value: function initialize() {
      this.onLoad = this.onLoad.bind(this);
    }
  }, {
    key: "connect",
    value: function connect() {
      window.addEventListener('load', this.onLoad);
    }
  }, {
    key: "onLoad",
    value: function onLoad() {
      var _this2 = this;

      var config = {
        slider: this.element,
        frame: this.frameTarget,
        list: this.listTarget,
        slides: this.slideTargets,
        mode: {
          // centered: true,
          fill: true,
          // infinite: true,
          multiple: true // loop: true,

        } // autoplay: {
        //     duration: 4000,
        //     pauseOnHover: true,
        // },

      };
      this.slider = new _opSlider.default(config);
      this.element.addEventListener('dragstart', function (e) {
        e.preventDefault();
      });
      this.imageTargets.forEach(function (target) {
        console.log(target);
        target.addEventListener('mouseover', _this2.handleMouseOver);
        target.addEventListener('mouseout', _this2.handleMouseOut);
      });
    }
  }]);

  return _default;
}(_stimulus.Controller);

exports.default = _default;

_defineProperty(_default, "targets", ['frame', 'list', 'slide', 'image']);

/***/ }),

/***/ "./mysite/resources/js/controllers/sticky_controller.js":
/*!**************************************************************!*\
  !*** ./mysite/resources/js/controllers/sticky_controller.js ***!
  \**************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

__webpack_require__(/*! core-js/modules/es7.symbol.async-iterator */ "./node_modules/core-js/modules/es7.symbol.async-iterator.js");

__webpack_require__(/*! core-js/modules/es6.symbol */ "./node_modules/core-js/modules/es6.symbol.js");

__webpack_require__(/*! core-js/modules/es6.object.define-property */ "./node_modules/core-js/modules/es6.object.define-property.js");

__webpack_require__(/*! core-js/modules/es6.object.create */ "./node_modules/core-js/modules/es6.object.create.js");

__webpack_require__(/*! core-js/modules/es6.object.set-prototype-of */ "./node_modules/core-js/modules/es6.object.set-prototype-of.js");

var _stickyfilljs = _interopRequireDefault(__webpack_require__(/*! stickyfilljs */ "./node_modules/stickyfilljs/dist/stickyfill.js"));

var _stimulus = __webpack_require__(/*! stimulus */ "./node_modules/stimulus/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var _default =
/*#__PURE__*/
function (_Controller) {
  _inherits(_default, _Controller);

  function _default() {
    _classCallCheck(this, _default);

    return _possibleConstructorReturn(this, _getPrototypeOf(_default).apply(this, arguments));
  }

  _createClass(_default, [{
    key: "connect",
    value: function connect() {
      _stickyfilljs.default.add(this.element);
    }
  }]);

  return _default;
}(_stimulus.Controller);

exports.default = _default;

/***/ }),

/***/ "./mysite/resources/js/controllers/window-height_controller.js":
/*!*********************************************************************!*\
  !*** ./mysite/resources/js/controllers/window-height_controller.js ***!
  \*********************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/***/ }),

/***/ "./mysite/resources/js/helpers/AF.js":
/*!*******************************************!*\
  !*** ./mysite/resources/js/helpers/AF.js ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

__webpack_require__(/*! core-js/modules/es6.object.define-property */ "./node_modules/core-js/modules/es6.object.define-property.js");

__webpack_require__(/*! core-js/modules/es6.function.bind */ "./node_modules/core-js/modules/es6.function.bind.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AF =
/*#__PURE__*/
function () {
  _createClass(AF, null, [{
    key: "instance",
    value: function instance() {
      if (this._instance) return this._instance;
      return this._instance = new this();
    }
  }]);

  function AF() {
    _classCallCheck(this, AF);

    _defineProperty(this, "_instance", void 0);

    _defineProperty(this, "_frame", null);

    _defineProperty(this, "_stopped", true);

    _defineProperty(this, "_oneRead", []);

    _defineProperty(this, "_oneWrite", []);

    _defineProperty(this, "_read", []);

    _defineProperty(this, "_write", []);

    this._animate = this._animate.bind(this);
    if (typeof window !== 'undefined') this.start();
  }

  _createClass(AF, [{
    key: "start",
    value: function start() {
      if (!this._stopped) return;
      this._stopped = false;

      this._animate();
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this._stopped) return;
      this._stopped = true;
      window.cancelAnimationFrame(this._frame);
    }
  }, {
    key: "_animate",
    value: function _animate() {
      var oW = this._oneWrite,
          oR = this._oneRead,
          r = this._read,
          w = this._write;
      var i; // do one read, remove and trigger; then trigger loop reads

      while (oR.length) {
        oR.shift()();
      }

      for (i = 0; i < r.length; i++) {
        r[i]();
      } // do one write, remove and trigger; then trigger loop writes


      while (oW.length) {
        oW.shift()();
      }

      for (i = 0; i < w.length; i++) {
        w[i]();
      }

      this._frame = window.requestAnimationFrame(this._animate);
    }
  }, {
    key: "onNextRead",
    value: function onNextRead(fn) {
      this._oneRead.push(fn);
    }
  }, {
    key: "onNextWrite",
    value: function onNextWrite(fn) {
      this._oneWrite.push(fn);
    }
  }, {
    key: "addRead",
    value: function addRead(fn) {
      this._read.push(fn);
    }
  }, {
    key: "addWrite",
    value: function addWrite(fn) {
      this._write.push(fn);
    }
  }, {
    key: "removeRead",
    value: function removeRead(fn) {
      var r = this._read,
          l = r.length;

      for (var i = 0; i < l; i++) {
        if (r[i] === fn) r.splice(i, 1);
      }
    }
  }, {
    key: "removeWrite",
    value: function removeWrite(fn) {
      var w = this._write,
          l = w.length;

      for (var i = 0; i < l; i++) {
        if (w[i] === fn) w.splice(i, 1);
      }
    }
  }]);

  return AF;
}();

var _default = AF;
exports.default = _default;

/***/ }),

/***/ "./mysite/resources/js/helpers/bezier-easing.js":
/*!******************************************************!*\
  !*** ./mysite/resources/js/helpers/bezier-easing.js ***!
  \******************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(/*! core-js/modules/es6.typed.float32-array */ "./node_modules/core-js/modules/es6.typed.float32-array.js");

/**
 * https://github.com/gre/bezier-easing
 * BezierEasing - use bezier curve for transition easing function
 * by Gaëtan Renaudeau 2014 - 2015 – MIT License
 */
// These values are established by empiricism with tests (tradeoff: performance VS precision)
var NEWTON_ITERATIONS = 4;
var NEWTON_MIN_SLOPE = 0.001;
var SUBDIVISION_PRECISION = 0.0000001;
var SUBDIVISION_MAX_ITERATIONS = 10;
var kSplineTableSize = 11;
var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
var float32ArraySupported = typeof Float32Array === 'function';

function A(aA1, aA2) {
  return 1.0 - 3.0 * aA2 + 3.0 * aA1;
}

function B(aA1, aA2) {
  return 3.0 * aA2 - 6.0 * aA1;
}

function C(aA1) {
  return 3.0 * aA1;
} // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.


function calcBezier(aT, aA1, aA2) {
  return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
} // Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.


function getSlope(aT, aA1, aA2) {
  return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
}

function binarySubdivide(aX, aA, aB, mX1, mX2) {
  var currentX,
      currentT,
      i = 0;

  do {
    currentT = aA + (aB - aA) / 2.0;
    currentX = calcBezier(currentT, mX1, mX2) - aX;

    if (currentX > 0.0) {
      aB = currentT;
    } else {
      aA = currentT;
    }
  } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);

  return currentT;
}

function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
  for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
    var currentSlope = getSlope(aGuessT, mX1, mX2);

    if (currentSlope === 0.0) {
      return aGuessT;
    }

    var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
    aGuessT -= currentX / currentSlope;
  }

  return aGuessT;
}

module.exports = function bezier(mX1, mY1, mX2, mY2) {
  if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) {
    throw new Error('bezier x values must be in [0, 1] range');
  } // Precompute samples table


  var sampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);

  if (mX1 !== mY1 || mX2 !== mY2) {
    for (var i = 0; i < kSplineTableSize; ++i) {
      sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
    }
  }

  function getTForX(aX) {
    var intervalStart = 0.0;
    var currentSample = 1;
    var lastSample = kSplineTableSize - 1;

    for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
      intervalStart += kSampleStepSize;
    }

    --currentSample; // Interpolate to provide an initial guess for t

    var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
    var guessForT = intervalStart + dist * kSampleStepSize;
    var initialSlope = getSlope(guessForT, mX1, mX2);

    if (initialSlope >= NEWTON_MIN_SLOPE) {
      return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
    } else if (initialSlope === 0.0) {
      return guessForT;
    } else {
      return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
    }
  }

  return function BezierEasing(x) {
    if (mX1 === mY1 && mX2 === mY2) {
      return x; // linear
    } // Because JavaScript number are imprecise, we should guarantee the extremes are right.


    if (x === 0) {
      return 0;
    }

    if (x === 1) {
      return 1;
    }

    return calcBezier(getTForX(x), mY1, mY2);
  };
};

/***/ }),

/***/ "./mysite/resources/js/helpers/ease-adv.js":
/*!*************************************************!*\
  !*** ./mysite/resources/js/helpers/ease-adv.js ***!
  \*************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(/*! core-js/modules/es6.object.define-property */ "./node_modules/core-js/modules/es6.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.linear = linear;
exports.easeInSine = easeInSine;
exports.easeOutSine = easeOutSine;
exports.easeInOutSine = easeInOutSine;
exports.easeInQuad = easeInQuad;
exports.easeOutQuad = easeOutQuad;
exports.easeInOutQuad = easeInOutQuad;
exports.easeInCubic = easeInCubic;
exports.easeOutCubic = easeOutCubic;
exports.easeInOutCubic = easeInOutCubic;
exports.easeInQuart = easeInQuart;
exports.easeOutQuart = easeOutQuart;
exports.easeInOutQuart = easeInOutQuart;
exports.easeInQuint = easeInQuint;
exports.easeOutQuint = easeOutQuint;
exports.easeInOutQuint = easeInOutQuint;
exports.easeInExpo = easeInExpo;
exports.easeOutExpo = easeOutExpo;
exports.easeInOutExpo = easeInOutExpo;
exports.easeInCirc = easeInCirc;
exports.easeOutCirc = easeOutCirc;
exports.easeInOutCirc = easeInOutCirc;
exports.easeInBack = easeInBack;
exports.easeOutBack = easeOutBack;
exports.easeInOutBack = easeInOutBack;
exports.easeInElastic = easeInElastic;
exports.easeOutElastic = easeOutElastic;
exports.easeInOutElastic = easeInOutElastic;
exports.easeOutBounce = easeOutBounce;
exports.easeInBounce = easeInBounce;
exports.easeInOutBounce = easeInOutBounce;

// Based on https://gist.github.com/gre/1650294
// No easing, no acceleration
function linear(t) {
  return t;
} // Slight acceleration from zero to full speed


function easeInSine(t) {
  return -1 * Math.cos(t * (Math.PI / 2)) + 1;
} // Slight deceleration at the end


function easeOutSine(t) {
  return Math.sin(t * (Math.PI / 2));
} // Slight acceleration at beginning and slight deceleration at end


function easeInOutSine(t) {
  return -0.5 * (Math.cos(Math.PI * t) - 1);
} // Accelerating from zero velocity


function easeInQuad(t) {
  return t * t;
} // Decelerating to zero velocity


function easeOutQuad(t) {
  return t * (2 - t);
} // Acceleration until halfway, then deceleration


function easeInOutQuad(t) {
  return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
} // Accelerating from zero velocity


function easeInCubic(t) {
  return t * t * t;
} // Decelerating to zero velocity


function easeOutCubic(t) {
  var t1 = t - 1;
  return t1 * t1 * t1 + 1;
} // Acceleration until halfway, then deceleration


function easeInOutCubic(t) {
  return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
} // Accelerating from zero velocity


function easeInQuart(t) {
  return t * t * t * t;
} // Decelerating to zero velocity


function easeOutQuart(t) {
  var t1 = t - 1;
  return 1 - t1 * t1 * t1 * t1;
} // Acceleration until halfway, then deceleration


function easeInOutQuart(t) {
  var t1 = t - 1;
  return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * t1 * t1 * t1 * t1;
} // Accelerating from zero velocity


function easeInQuint(t) {
  return t * t * t * t * t;
} // Decelerating to zero velocity


function easeOutQuint(t) {
  var t1 = t - 1;
  return 1 + t1 * t1 * t1 * t1 * t1;
} // Acceleration until halfway, then deceleration


function easeInOutQuint(t) {
  var t1 = t - 1;
  return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * t1 * t1 * t1 * t1 * t1;
} // Accelerate exponentially until finish


function easeInExpo(t) {
  if (t === 0) {
    return 0;
  }

  return Math.pow(2, 10 * (t - 1));
} // Initial exponential acceleration slowing to stop


function easeOutExpo(t) {
  if (t === 1) {
    return 1;
  }

  return -Math.pow(2, -10 * t) + 1;
} // Exponential acceleration and deceleration


function easeInOutExpo(t) {
  if (t === 0 || t === 1) {
    return t;
  }

  var scaledTime = t * 2;
  var scaledTime1 = scaledTime - 1;

  if (scaledTime < 1) {
    return 0.5 * Math.pow(2, 10 * scaledTime1);
  }

  return 0.5 * (-Math.pow(2, -10 * scaledTime1) + 2);
} // Increasing velocity until stop


function easeInCirc(t) {
  var scaledTime = t / 1;
  return -1 * (Math.sqrt(1 - scaledTime * t) - 1);
} // Start fast, decreasing velocity until stop


function easeOutCirc(t) {
  var t1 = t - 1;
  return Math.sqrt(1 - t1 * t1);
} // Fast increase in velocity, fast decrease in velocity


function easeInOutCirc(t) {
  var scaledTime = t * 2;
  var scaledTime1 = scaledTime - 2;

  if (scaledTime < 1) {
    return -0.5 * (Math.sqrt(1 - scaledTime * scaledTime) - 1);
  }

  return 0.5 * (Math.sqrt(1 - scaledTime1 * scaledTime1) + 1);
} // Slow movement backwards then fast snap to finish


function easeInBack(t) {
  var magnitude = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1.70158;
  return t * t * ((magnitude + 1) * t - magnitude);
} // Fast snap to backwards point then slow resolve to finish


function easeOutBack(t) {
  var magnitude = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1.70158;
  var scaledTime = t / 1 - 1;
  return scaledTime * scaledTime * ((magnitude + 1) * scaledTime + magnitude) + 1;
} // Slow movement backwards, fast snap to past finish, slow resolve to finish


function easeInOutBack(t) {
  var magnitude = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1.70158;
  var scaledTime = t * 2;
  var scaledTime2 = scaledTime - 2;
  var s = magnitude * 1.525;

  if (scaledTime < 1) {
    return 0.5 * scaledTime * scaledTime * ((s + 1) * scaledTime - s);
  }

  return 0.5 * (scaledTime2 * scaledTime2 * ((s + 1) * scaledTime2 + s) + 2);
} // Bounces slowly then quickly to finish


function easeInElastic(t) {
  var magnitude = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.7;

  if (t === 0 || t === 1) {
    return t;
  }

  var scaledTime = t / 1;
  var scaledTime1 = scaledTime - 1;
  var p = 1 - magnitude;
  var s = p / (2 * Math.PI) * Math.asin(1);
  return -(Math.pow(2, 10 * scaledTime1) * Math.sin((scaledTime1 - s) * (2 * Math.PI) / p));
} // Fast acceleration, bounces to zero


function easeOutElastic(t) {
  var magnitude = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.7;
  var p = 1 - magnitude;
  var scaledTime = t * 2;

  if (t === 0 || t === 1) {
    return t;
  }

  var s = p / (2 * Math.PI) * Math.asin(1);
  return Math.pow(2, -10 * scaledTime) * Math.sin((scaledTime - s) * (2 * Math.PI) / p) + 1;
} // Slow start and end, two bounces sandwich a fast motion


function easeInOutElastic(t) {
  var magnitude = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.65;
  var p = 1 - magnitude;

  if (t === 0 || t === 1) {
    return t;
  }

  var scaledTime = t * 2;
  var scaledTime1 = scaledTime - 1;
  var s = p / (2 * Math.PI) * Math.asin(1);

  if (scaledTime < 1) {
    return -0.5 * (Math.pow(2, 10 * scaledTime1) * Math.sin((scaledTime1 - s) * (2 * Math.PI) / p));
  }

  return Math.pow(2, -10 * scaledTime1) * Math.sin((scaledTime1 - s) * (2 * Math.PI) / p) * 0.5 + 1;
} // Bounce to completion


function easeOutBounce(t) {
  var scaledTime = t / 1;

  if (scaledTime < 1 / 2.75) {
    return 7.5625 * scaledTime * scaledTime;
  } else if (scaledTime < 2 / 2.75) {
    var scaledTime2 = scaledTime - 1.5 / 2.75;
    return 7.5625 * scaledTime2 * scaledTime2 + 0.75;
  } else if (scaledTime < 2.5 / 2.75) {
    var _scaledTime = scaledTime - 2.25 / 2.75;

    return 7.5625 * _scaledTime * _scaledTime + 0.9375;
  } else {
    var _scaledTime2 = scaledTime - 2.625 / 2.75;

    return 7.5625 * _scaledTime2 * _scaledTime2 + 0.984375;
  }
} // Bounce increasing in velocity until completion


function easeInBounce(t) {
  return 1 - easeOutBounce(1 - t);
} // Bounce in and bounce out


function easeInOutBounce(t) {
  if (t < 0.5) {
    return easeInBounce(t * 2) * 0.5;
  }

  return easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
}

/***/ }),

/***/ "./mysite/resources/js/helpers/is-ie.js":
/*!**********************************************!*\
  !*** ./mysite/resources/js/helpers/is-ie.js ***!
  \**********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(/*! core-js/modules/es6.object.define-property */ "./node_modules/core-js/modules/es6.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.detectIE = detectIE;
exports.isIE = void 0;

__webpack_require__(/*! core-js/modules/es6.array.index-of */ "./node_modules/core-js/modules/es6.array.index-of.js");

function detectIE() {
  var ua = window.navigator.userAgent; // Test values; Uncomment to check result …
  // IE 10
  // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
  // IE 11
  // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
  // Edge 12 (Spartan)
  // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
  // Edge 13
  // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

  var msie = ua.indexOf('MSIE ');

  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  var trident = ua.indexOf('Trident/');

  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  var edge = ua.indexOf('Edge/');

  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  } // other browser


  return false;
}

var isIE = detectIE();
exports.isIE = isIE;

/***/ }),

/***/ "./mysite/resources/js/helpers/is-mobile.js":
/*!**************************************************!*\
  !*** ./mysite/resources/js/helpers/is-mobile.js ***!
  \**************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(/*! core-js/modules/es6.object.define-property */ "./node_modules/core-js/modules/es6.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkMobile = checkMobile;
exports.isMobile = exports.mobileAndTabletcheck = void 0;

function checkMobile() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  var MOBILE_WINDOW = /windows phone/i.test(userAgent);
  var MOBILE_ANDROID = /android/i.test(userAgent);
  var MOBILE_IOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  return MOBILE_IOS || MOBILE_ANDROID || MOBILE_WINDOW;
}

var mobileAndTabletcheck = function mobileAndTabletcheck() {
  var check = false;

  (function (a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);

  return check;
};

exports.mobileAndTabletcheck = mobileAndTabletcheck;
var isMobile = checkMobile();
exports.isMobile = isMobile;

/***/ }),

/***/ "./mysite/resources/js/helpers/rect.js":
/*!*********************************************!*\
  !*** ./mysite/resources/js/helpers/rect.js ***!
  \*********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Rect = void 0;

__webpack_require__(/*! core-js/modules/es6.object.define-property */ "./node_modules/core-js/modules/es6.object.define-property.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Rect =
/*#__PURE__*/
function () {
  function Rect(_ref) {
    var el = _ref.el;

    _classCallCheck(this, Rect);

    this.el = el;
    this.tick();
  }

  _createClass(Rect, [{
    key: "tick",
    value: function tick() {
      var rect = this.el.getBoundingClientRect();
      this.top = rect.top;
      this.right = rect.right;
      this.bottom = rect.bottom;
      this.left = rect.left;
      this.height = rect.height;
      this.width = rect.width;
      this.winHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    }
  }, {
    key: "progress",
    get: function get() {
      return 1 - (this.top + this.height) / (this.winHeight + this.height);
    }
  }, {
    key: "altProgress",
    get: function get() {
      return 1 - (this.top + this.height) / this.height;
    }
  }]);

  return Rect;
}();

exports.Rect = Rect;

/***/ }),

/***/ "./mysite/resources/js/main.js":
/*!*************************************!*\
  !*** ./mysite/resources/js/main.js ***!
  \*************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(/*! ./styles */ "./mysite/resources/js/styles.js");

__webpack_require__(/*! core-js/fn/array/find */ "./node_modules/core-js/fn/array/find.js");

__webpack_require__(/*! core-js/fn/array/find-index */ "./node_modules/core-js/fn/array/find-index.js");

__webpack_require__(/*! core-js/fn/array/from */ "./node_modules/core-js/fn/array/from.js");

__webpack_require__(/*! core-js/fn/map */ "./node_modules/core-js/fn/map.js");

__webpack_require__(/*! core-js/fn/object/assign */ "./node_modules/core-js/fn/object/assign.js");

__webpack_require__(/*! core-js/fn/promise */ "./node_modules/core-js/fn/promise.js");

__webpack_require__(/*! core-js/fn/set */ "./node_modules/core-js/fn/set.js");

__webpack_require__(/*! isomorphic-fetch */ "./node_modules/isomorphic-fetch/fetch-npm-browserify.js");

__webpack_require__(/*! element-closest */ "./node_modules/element-closest/element-closest.js");

__webpack_require__(/*! objectFitPolyfill */ "./node_modules/objectFitPolyfill/dist/objectFitPolyfill.min.js");

var _stimulus = __webpack_require__(/*! stimulus */ "./node_modules/stimulus/index.js");

var _webpackHelpers = __webpack_require__(/*! stimulus/webpack-helpers */ "./node_modules/stimulus/webpack-helpers.js");

var _windowHeight = _interopRequireDefault(__webpack_require__(/*! ./components/window-height */ "./mysite/resources/js/components/window-height.js"));

var _App = _interopRequireDefault(__webpack_require__(/*! ./components/webgl/App */ "./mysite/resources/js/components/webgl/App.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import objectFit from "object-fit";
var application = _stimulus.Application.start();

var context = __webpack_require__(/*! ./controllers */ "./mysite/resources/js/controllers recursive \\.js$");

application.load((0, _webpackHelpers.definitionsFromContext)(context));
new _App.default();

function run() {
  new _windowHeight.default();
  objectFitPolyfill();
}

window.addEventListener("load", run);

/***/ }),

/***/ "./mysite/resources/js/styles.js":
/*!***************************************!*\
  !*** ./mysite/resources/js/styles.js ***!
  \***************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(/*! ../scss/main.scss */ "./mysite/resources/scss/main.scss");

/***/ }),

/***/ "./mysite/resources/scss/main.scss":
/*!*****************************************!*\
  !*** ./mysite/resources/scss/main.scss ***!
  \*****************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./mysite/resources/shaders/plain.frag":
/*!*********************************************!*\
  !*** ./mysite/resources/shaders/plain.frag ***!
  \*********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

module.exports = "precision highp float;\nuniform sampler2D tDiffuse;\nuniform float time;\nvarying vec2 vUv;\n\n/* discontinuous pseudorandom uniformly distributed in [-0.5, +0.5]^3 */\nvec3 random3(vec3 c) {\n    float j = 4096.0*sin(dot(c,vec3(17.0, 59.4, 15.0)));\n    vec3 r;\n    r.z = fract(512.0*j);\n    j *= .125;\n    r.x = fract(512.0*j);\n    j *= .125;\n    r.y = fract(512.0*j);\n    return r-0.5;\n}\n\n/* skew constants for 3d simplex functions */\nconst float F3 =  0.3333333;\nconst float G3 =  0.1666667;\n\n/* 3d simplex noise */\nfloat simplex3d(vec3 p) {\n     /* 1. find current tetrahedron T and it's four vertices */\n     /* s, s+i1, s+i2, s+1.0 - absolute skewed (integer) coordinates of T vertices */\n     /* x, x1, x2, x3 - unskewed coordinates of p relative to each of T vertices*/\n\n     /* calculate s and x */\n     vec3 s = floor(p + dot(p, vec3(F3)));\n     vec3 x = p - s + dot(s, vec3(G3));\n\n     /* calculate i1 and i2 */\n     vec3 e = step(vec3(0.0), x - x.yzx);\n     vec3 i1 = e*(1.0 - e.zxy);\n     vec3 i2 = 1.0 - e.zxy*(1.0 - e);\n\n     /* x1, x2, x3 */\n     vec3 x1 = x - i1 + G3;\n     vec3 x2 = x - i2 + 2.0*G3;\n     vec3 x3 = x - 1.0 + 3.0*G3;\n\n     /* 2. find four surflets and store them in d */\n     vec4 w, d;\n\n     /* calculate surflet weights */\n     w.x = dot(x, x);\n     w.y = dot(x1, x1);\n     w.z = dot(x2, x2);\n     w.w = dot(x3, x3);\n\n     /* w fades from 0.6 at the center of the surflet to 0.0 at the margin */\n     w = max(0.6 - w, 0.0);\n\n     /* calculate surflet components */\n     d.x = dot(random3(s), x);\n     d.y = dot(random3(s + i1), x1);\n     d.z = dot(random3(s + i2), x2);\n     d.w = dot(random3(s + 1.0), x3);\n\n     /* multiply d by w^4 */\n     w *= w;\n     w *= w;\n     d *= w;\n\n     /* 3. return the sum of the four surflets */\n     return dot(d, vec4(52.0));\n}\n\n/* const matrices for 3d rotation */\nconst mat3 rot1 = mat3(-0.37, 0.36, 0.85,-0.14,-0.93, 0.34,0.92, 0.01,0.4);\nconst mat3 rot2 = mat3(-0.55,-0.39, 0.74, 0.33,-0.91,-0.24,0.77, 0.12,0.63);\nconst mat3 rot3 = mat3(-0.71, 0.52,-0.47,-0.08,-0.72,-0.68,-0.7,-0.45,0.56);\n\nfloat simplex3d_fractal(vec3 m) {\n    return   0.5333333*simplex3d(m*rot1)\n            +0.2666667*simplex3d(2.0*m*rot2)\n            +0.1333333*simplex3d(4.0*m*rot3)\n            +0.0666667*simplex3d(8.0*m);\n}\n\n\n\nfloat lightness = 1.0;\nfloat speed = 0.00005;\nfloat noiseSize = 1.0;\nfloat intensity = 0.1;\n\nvoid main() {\n\n    vec3 p3 = vec3(time * speed,  vUv.x, vUv.y);\n    float shade = simplex3d_fractal(p3*noiseSize+4.0);\n    float shift = sin(vUv.x*6.2856*1. + time*0.001) * shade;\n    vec2 off = vUv + shade*intensity;\n    vec4 frag = texture2D(tDiffuse, off);\n\n    frag.xyz *= lightness;\n\n\n    gl_FragColor = frag;\n}"

/***/ }),

/***/ "./mysite/resources/shaders/plain.vert":
/*!*********************************************!*\
  !*** ./mysite/resources/shaders/plain.vert ***!
  \*********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

module.exports = "precision highp float;\nvarying vec2 vUv;\nuniform vec2 size;\n\n\nvoid main() {\n    vUv = uv;\n\n    float offX = (1.- size.x) * 0.5;\n    float offY = (1.- size.y) * 0.9;\n\n    vUv *= size;\n    vUv.x += offX;\n    vUv.y += offY;\n\n    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}"

/***/ }),

/***/ 0:
/*!*******************************************!*\
  !*** multi ./mysite/resources/js/main.js ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! ./mysite/resources/js/main.js */"./mysite/resources/js/main.js");


/***/ })

},[0]);


// WEBPACK FOOTER //
// main.ae8391a1.js